export const types = {

  authChecking: '[auth] Checking login state',
  authCheckingFinish: '[auth] Finish Checking login state',
  authStartLogin: '[auth] Start Login',
  authLogin: '[auth] Login',
  authStartRegister: '[auth] Start Register',
  authLogout: '[auth] Logout',
  authStartTokenRenew: '[auth] Start Token Renew',
  codigoValidadoGoogle: '[auth] codigo Validado Google',

  afiliacionesAfiliadoSeleccionado: '[afiliaciones] Seleccion Afiliado',
  afiliacionesAfiliadoLimpiarSeleccion: '[afiliaciones] Limpiar Seleccion Afiliado',
  afiliacionesAfiliadoConsultaLimpiarSeleccion: '[afiliaciones] Limpiar Seleccion de Afiliado consulta',
  afiliacionesAfiliadoNuevoLimpiarSeleccion: '[afiliaciones] Limpiar Seleccion de nuevo Afiliado',
  afiliacionesAfiliadoUpdated: '[afiliaciones] Actualizar Afiliado',
  afiliacionesActualizarDocumentacion: '[afiliaciones] Actualizar Documentacion Afiliado',
  afiliacionesActualizarDatosPersonales: '[afiliaciones] Actualizar Datos Afiliado',
  afiliacionesActualizarSeguimiento: '[afiliaciones] Actualizar Seguimiento Afiliado',
  preafiliacionesActualizarDocumentacion: '[afiliaciones] Actualizar Documentacion Preafiliado',
  afiliacionesActualizarSinFicha: '[afiliaciones] Actualizar Sin Ficha Afiliado',
  afiliacionesSetObrasSocialesSuccess: '[afiliaciones] Get Obras Sociales Succes',
  afiliacionesSetObrasSocialesError: '[afiliaciones] Get Obras Sociales Error',
  afiliacionesAfiliadoReloadPlanConvenio: '[afiliaciones] Seleccion Afiliado / Reload PlanConvenio',

  autorizacionesSetStep: '[autorizaciones] Set Step',
  autorizacionesSetAfiliadoSeleccionado: '[autorizaciones] Set Afiliado Seleccionado',
  autorizacionesCleanAfiliadoSeleccionado: '[autorizaciones] Clean Afiliado Seleccionado',
  autorizacionesGetDetalleSolicitudAuditoriaPorIdSolicitudSucces: '[autorizaciones] autorizacionesGetDetalleSolicitudAuditoriaPorIdSolicitudSucces',
  autorizacionesGetDetalleSolicitudPorIdSolicitudSucces: '[autorizaciones] autorizacionesGetDetalleSolicitudPorIdSolicitudSucces',
  autorizacionesGetSolicitudPorIdSolicitudError: '[autorizaciones]  Get Solicitud Por Solicitud Error',
  autorizacionesGetContratoPresupuestoSuccess: '[autorizaciones]  Get Contrato Presupuesto Success',
  autorizacionesGetContratoPresupuestoError: '[autorizaciones]  Get Contrato Presupuesto Error',
  autorizacionesGetTiposSolicitudesSuccess: '[autorizaciones] Get Tipos Solicitudes Success',
  autorizacionesGetTiposSolicitudesError: '[autorizaciones] Get Tipos Solicitudes Error',
  autorizacionesGetSolicitudesSuccess: '[autorizaciones] Get Solicitudes Success',
  autorizacionesGetSolicitudesEnCargaSuccess: '[autorizaciones] Get Solicitudes En Carga Success',
  autorizacionesGetSolicitudesSeguimientoSuccess: '[autorizaciones] Get Solicitudes Seguimiento Success',
  autorizacionesGetSolicitudesError: '[autorizaciones] Get Solicitudes Error',
  autorizacionesGetSolicitudesEnCargaError: '[autorizaciones] Get Solicitudes En Carga Error',
  autorizacionesGetContadoresSolicitudesSuccess: '[autorizaciones] Get Contadores Solicitudes Success',
  autorizacionesGetContadoresSolicitudesError: '[autorizaciones] Get Contadores Solicitudes Error',
  autorizacionesCleanSolicitudes: '[autorizaciones] Clean Solicitudes',
  autorizacionesGetSolicitudesPendientesSuccess: '[autorizaciones] Get Solicitudes Pendientes Success',
  autorizacionesGetSolicitudesPendientesError: '[autorizaciones] Get Solicitudes Pendientes Error',
  autorizacionesCleanSolicitudesPendientes: '[autorizaciones] Clean Solicitudes Pendientes',
  autorizacionesSolicitudesMarcarTomada: '[autorizaciones] Solicitudes Marcar Tomada',
  autorizacionesPresupuestosMarcarTomada: '[autorizaciones] Presupuestos Marcar Tomada',
  autorizacionesAddPractica: '[autorizaciones] Add Practica',
  autorizacionesSetPeriodosPractica: '[autorizaciones] Set Periodos Practica',
  autorizacionesGetLocalidadesPorZonaSuccess: '[autorizaciones] Get Localidades Por Zona Success',
  autorizacionesGetLocalidadesPorZonaError: '[autorizaciones] Get Localidades Por Zona Error',
  autorizacionesSetSolicitudSeleccionada: '[autorizaciones] Set Solicitud Seleccionada',
  autorizacionesSetShowForm: '[autorizaciones] Set Show Form',
  autorizacionesGetDocumentacionSuccess: '[autorizaciones] Get Documentacion Success',
  autorizacionesGetDocumentacionError: '[autorizaciones] Get Documentacion Error',
  autorizacionesGetDocumentacionPracticaSuccess: '[autorizaciones] Get Documentacion Practica Success',
  autorizacionesGetDocumentacionPracticaError: '[autorizaciones] Get Documentacion Practica Error',
  autorizacionesGetTiposDocumentacionSuccess: '[autorizaciones] Get Tipos Documentacion Solicitud Success',
  autorizacionesAddTiposDocumentacion: '[autorizaciones] Add Tipos Documentacion Solicitud Success',
  autorizacionesSetTiposDocumentacion: '[autorizaciones] Set Tipos Documentacion Solicitud Success',
  autorizacionesDeleteTiposDocumentacion: '[autorizaciones] Delete Tipos Documentacion Solicitud Success',
  autorizacionesGetTiposDocumentacionError: '[autorizaciones] Get Tipos Documentacion Solicitud Error',
  autorizacionesGetTiposDocuSuccess: '[autorizaciones] Get Tipos Documentacion Success',
  autorizacionesAddTiposDocu: '[autorizaciones] Add Tipos Documentacion Success',
  autorizacionesSetTiposDocu: '[autorizaciones] Set Tipos Documentacion Success',
  autorizacionesDeleteTiposDocu: '[autorizaciones] Delete Tipos Documentacion Success',
  autorizacionesGetTiposDocuError: '[autorizaciones] Get Tipos Documentacion Error',
  autorizacionesGetTiposDocumentacionPresupuestoSuccess: '[autorizaciones] Get Tipos Documentacion Presupuesto Success',
  autorizacionesAddTiposDocumentacionPresupuesto: '[autorizaciones] Add Tipos Documentacion Presupuesto Success',
  autorizacionesSetTiposDocumentacionPresupuesto: '[autorizaciones] Set Tipos Documentacion Presupuesto Success',
  autorizacionesDeleteTiposDocumentacionPresupuesto: '[autorizaciones] Delete Tipos Documentacion Presupuesto Success',
  autorizacionesGetTiposDocumentacionPresupuestoError: '[autorizaciones] Get Tipos Documentacion Presupuesto Error',
  autorizacionesGetTiposDocumentacionPracticaSolicitudSuccess: '[autorizaciones] Get Tipos Documentacion Practica Solicitud Success',
  autorizacionesAddTiposDocumentacionPracticaSolicitud: '[autorizaciones] Add Tipos Documentacion Practica Solicitud Success',
  autorizacionesSetTiposDocumentacionPracticaSolicitud: '[autorizaciones] Set Tipos Documentacion Practica Solicitud Success',
  autorizacionesDeleteTiposDocumentacionPracticaSolicitud: '[autorizaciones] Delete Tipos Documentacion Practica Solicitud Success',
  autorizacionesGetTiposDocumentacionPracticaSolicitudError: '[autorizaciones] Get Tipos Documentacion Practica Solicitud Error',
  autorizacionesGetTiposDocuComboSuccess: '[autorizaciones] Get Tipos Documentacion combo Success',
  autorizacionesGetTiposDocuComboError: '[autorizaciones] Get Tipos Documentacion combo Error',
  autorizacionesSolicitudesDesmarcarLiberada: '[autorizaciones] SolicitudesDesmarcarLiberada',
  seleccionSolicitudSeleccionadaBandejaSurge: '[autorizaciones] seleccion solicitud para bandeja surge imagenes',
  autorizacionesGetPracticasSolicitudSeleccionadaSuccess: '[autorizaciones] Set Practicas de Solicitud Seleccionada',
  autorizacionesGetPracticasPendientesDenunciaSolicitudSeleccionadaSuccess: '[autorizaciones] Set Practicas Pendientes Denuncia de Solicitud Seleccionada',
  autorizacionesSetPracticas: '[autorizaciones] Set Practicas',
  autorizacionesSetPracticasPendientesDenuncia: '[autorizaciones] Set Practicas PendientesDenuncia',
  autorizacionesGetPracticasSuccess: '[autorizaciones] Get Practicas Success',
  autorizacionesGetPracticasError: '[autorizaciones] Get Practicas Error',
  autorizacionesUpdateSolicitudSeleccionada: '[autorizaciones] Update Solicitud Seleccionada',
  autorizacionesGetTiposNotasSuccess: '[autorizaciones] Get Tipos Notas Success',
  autorizacionesGetTiposNotasError: '[autorizaciones] Get Tipos Notas Error',
  autorizacionesGetNotasSuccess: '[autorizaciones] Get Notas Success',
  autorizacionesGetNotasError: '[autorizaciones] Get Notas Error',
  autorizacionesGetTrackingNotasSuccess: '[autorizaciones] Get Tracking Notas Success',
  autorizacionesGetTrackingNotasError: '[autorizaciones] Get Tracking Notas Error',
  autorizacionesGetBandejasSuccess: '[autorizaciones] Get Bandejas Success',
  autorizacionesGetBandejasError: '[autorizaciones] Get Bandejas Error',
  autorizacionesGetBandejasUsuarioSuccess: '[autorizaciones] Get Bandejas Usuario Success',
  autorizacionesGetBandejasUsuarioError: '[autorizaciones] Get Bandejas Usuario Error',
  autorizacionesClearReducer: '[autorizaciones] Clear Reducer',
  autorizacionesClearSolicitudYPracticas: '[autorizaciones] Clear Solicitud Y Practicas',
  autorizacionesGetTrackingSolicitudSuccess: '[autorizaciones] Get Tracking Solicitud Success',
  autorizacionesGetTrackingSolicitudError: '[autorizaciones] Get Tracking Solicitud Error',
  autorizacionesGetTrackingPresupuestoSuccess: '[autorizaciones] Get Tracking Presupuesto Success',
  autorizacionesGetTrackingPresupuestoError: '[autorizaciones] Get Tracking Presupuesto Error',
  autorizacionesUpdateEstadoSolicitudes: '[autorizaciones] Update Estado Solicitudes',
  autorizacionesUpdateEstadoPresupuestos: '[autorizaciones] Update Estado Presupuestos',
  autorizacionesGetNomencladorBandejaSuccess: '[autorizaciones] Get Nomenclador Bandeja Success',
  autorizacionesGetNomencladorBandejaError: '[autorizaciones] Get Nomenclador Bandeja Error',
  autorizacionesUpdateNomencladorBandeja: '[autorizaciones] Update Nomenclador Bandeja',
  autorizacionesGetSectoresInternacionSuccess: '[autorizaciones] Get Sectores Internacion Success',
  autorizacionesGetSectoresInternacionError: '[autorizaciones] Get Sectores Internacion Error',
  autorizacionesGetEfectorDenunciaInternacionSuccess: '[autorizaciones] Get Efector Denuncia Internacion Success',
  autorizacionesGetEfectorDenunciaInternacionError: '[autorizaciones] Get EfectorDenuncia Internacion Error',
  autorizacionesUpdateEfectorDenunciaInternacion: '[autorizaciones] Update EfectorDenuncia Internacion',
  autorizacionesClearConsumosAfiliado: '[autorizaciones] Clear Consumos Afiliado',
  autorizacionesGetConsumosAfiliadoSuccess: '[autorizaciones] Get Consumos Afiliado Success',
  autorizacionesGetConsumosAfiliadoError: '[autorizaciones] Get Consumos Afiliado Error',
  autorizacionesGetTiposObservacionesSuccess: '[autorizaciones] Get Tipos Observaciones Success',
  autorizacionesGetTiposObservacionesError: '[autorizaciones] Get Tipos Observaciones Error',
  autorizacionesGetMotivoCierreDenunciaInterDomSuccess: '[autorizaciones] Get Motivo Cierre Denuncia Inter Dom Success',
  autorizacionesGetMotivoCierreDenunciaInterDomError: '[autorizaciones] Get Motivo Cierre Denuncia Inter Dom Error',
  autorizacionesGetObservacionesSuccess: '[autorizaciones] Get Observaciones Success',
  autorizacionesGetObservacionesError: '[autorizaciones] Get Observaciones Error',
  autorizacionesGetPresupuestosSuccess: '[autorizaciones] Get Presupuestos Success',
  autorizacionesGetPresupuestosError: '[autorizaciones] Get Presupuestos Error',
  autorizacionesGetContadoresPresupuestosSuccess: '[autorizaciones] Get Contadores Presupuestos Success',
  autorizacionesGetContadoresPresupuestosError: '[autorizaciones] Get Contadores Presupuestos Error',
  autorizacionesCleanPresupuestos: '[autorizaciones] Clean Presupuestos',
  autorizacionesSetPresupustoSeleccionado: '[autorizaciones] Set Presupuesto Seleccionado',
  autorizacionesUpdatePrespuestoSeleccionado: '[autorizaciones] Update Presupuesto Seleccionado',
  autorizacionesEmpadronamientoSolicitud: '[autorizacionesEmpadronamientoSolicitud]  Traida de Empadronamiento Solicitud Success',
  autorizacionesGetContadoresSolicitudesClean: '[autorizaciones] Clean Contadores Autorizaciones',
  autorizacionesGetSolicitudesInternacionSuccess: '[autorizaciones] Traer internaciones para modificar success',
  autorizacionesGetSolicitudesRelacionadasSuccess: '[autorizaciones] Traer solicitudes relacionadas success',
  autorizacionesGetSolicitudesRelacionadasError: '[autorizaciones] Traer solicitudes relacionadas error',
  autorizacionesGetMotivoCierreOxigenoSuccess: '[autorizaciones] Get Motivo Cierre Oxigeno Success',
  autorizacionesGetMotivoCierreOxigenoError: '[autorizaciones] Get Motivo Cierre Oxigeno Error',
  autorizacionesSetRetomandoAppMobileTrue: '[autorizaciones] Seteando TRUE SolicAppMobile',
  autorizacionesSetRetomandoAppMobileFalse: '[autorizaciones] Seteando FALSE SolicAppMobile',
  autorizacionesGetAfiliadoRecuperoSuccess: '[autorizaciones] get afiliados recupero success',
  autorizacionesGetSAfiliadoRecuperoError: '[autorizaciones] get afiliados recupero error',

  trackingAbmClearReducer: '[trackingAbm] Clear Reducer',
  trackingAbmGetTrackingSuccess: '[trackingAbm] Get Tracking Abm Success',
  trackingAbmGetTrackingError: '[trackingAbm] Get Tracking Abm Error',

  solicitudesSeguimientoSucces: '[solicitudes Seguimiento] Traida de solicitudes Seguimiento Success',
  solicitudesSeguimientoDelete: '[solicitudes Seguimiento] Traida de solicitudes Seguimiento Delete',
  solicitudesSeguimientoError: '[solicitudes Seguimiento] Traida de solicitudes Seguimiento Error',
  solicitudesSeguimientoAgregar: '[solicitudes Seguimiento] Traida de solicitudes Seguimiento Agregar',

  solicitudesTomadasSuccess: '[solicitudes Tomadas] Traida de solicitudes Tomadas Success',
  solicitudesTomadasError: '[solicitudes Tomadas] Solicitudes Tomadas Error',
  solicitudesTomadasUsuarioSuccess: '[solicitudes Tomadas] Traida de solicitudes Tomadas Por Usuario Success',
  solicitudesTomadasUsuarioError: '[solicitudes Tomadas] Solicitudes Tomadas Por Usuario Usuario Error',
  solicitudesTomadasUsuarioAgregar: '[solicitudes Tomadas] Agregar solicitudes Tomadas',
  solicitudesTomadasLiberar: '[solicitudes Tomadas] Liberar solicitudes Tomadas',
  solicitudesTomadasUsuarioLiberar: '[solicitudes Tomadas] Liberar solicitudes Tomadas Usuario',
  solicitudesTomadasLimpiar: '[solicitudes Tomadas] Limpia solicitudes Tomadas',

  presupuestosTomadosSuccess:
    '[presupuestos Tomados] Traida de presupuestos Tomados Success',
  presupuestosTomadosError: '[presupuestos Tomados] Solicitudes Tomados Error',
  presupuestosTomadosUsuarioSuccess:
    '[presupuestos Tomados] Traida de presupuestos Tomados Por Usuario Success',
  presupuestosTomadosUsuarioError:
    '[presupuestos Tomados] Solicitudes Tomados Por Usuario Usuario Error',
  presupuestosTomadosUsuarioAgregar:
    '[presupuestos Tomados] Agregar presupuestos Tomados',
  presupuestosTomadosLiberar:
    '[presupuestos Tomados] Liberar presupuestos Tomados',
  presupuestosTomadosUsuarioLiberar:
    '[presupuestos Tomados] Liberar presupuestos Tomados Usuario',
  presupuestosTomadosLimpiar:
    '[presupuestos Tomados] Limpia presupuestos Tomados',
  comprobantesTomadosLiberarTomadoPorIdPresupuesto:
    '[presupuestos Tomados] libera presupuestos Tomados en item',

  contratacionesPrespuestoXidTraerStart:
    '[contrataciones] Start Traer PrespuestoXid',
  contratacionesPrespuestoXidSetear: '[contrataciones] Setear PrespuestoXid',
  contratacionesPrespuestoXidTraerError: '[contrataciones] Error PrespuestoXid',
  contratacionesPrespuestoXidClean: '[contrataciones] Clean PrespuestoXid',

  contratacionesTraerStart: '[contrataciones] Start Traer Datos',
  contratacionesTraerError: '[contrataciones] Traer Datos Error',
  contratacionesTraerSuccess: '[contrataciones] Traer Datos Exitoso',

  contratacionesMatriculasMedicasTraerStart:
    '[contrataciones] Start Traer Matriculas',
  contratacionesMatriculasMedicasTraerSuccess:
    '[contrataciones] Success Matriculas',
  contratacionesMatriculasMedicasTraerError:
    '[contrataciones] Error Matriculas',

  contratacionesMotivosBajaTraerStart:
    '[contrataciones] Start Traer Motivos Baja',
  contratacionesMotivosBajaTraerSuccess:
    '[contrataciones] Success Motivos Baja',
  contratacionesMotivosBajaTraerError: '[contrataciones] Error Motivos Baja',

  contratacionesNomencladorTraerStart: '[contrataciones] Start traer Nomencladores',
  contratacionesNomencladorTraerSuccess: '[contrataciones] Success traer Nomencladores',
  contratacionesNomencladorTraerError: '[contrataciones] Error traer Nomencladores',

  contratacionesDataContrato: '[contrataciones] Set data contrato',

  contratacionesEspecialidadTraerStart:
    '[contrataciones] Start Traer Especialidad',
  contratacionesEspecialidadTraerError:
    '[contrataciones] Error Traer Especialidad',
  contratacionesEspecialidadTraerSuccess:
    '[contrataciones] Success Traer Especialidad',

  contratacionesTraerTipoContactoStart: '[contrataciones] Start Traer Contacto',
  contratacionesTraerTipoContactoError: '[contrataciones] Traer Contacto Error',
  contratacionesTraerTipoContactoSuccess: '[contrataciones] Traer Contacto Exitoso',

  contratacionesTraerContactoStart: '[contrataciones] Start Traer Contactos usuario',
  contratacionesTraerContactoError: '[contrataciones] Traer Contactos usuario Error',
  contratacionesTraerContactoSuccess: '[contrataciones] Traer Contactos usuario Exitoso',

  contratacionesTraerObservacionesContactoStart: '[contrataciones] Start Traer Observaciones Contactos usuario',
  contratacionesTraerObservacionesContactoError: '[contrataciones] Traer Observaciones Contactos usuario Error',
  contratacionesTraerObservacionesContactoSuccess: '[contrataciones] Traer Observaciones Contactos usuario Exitoso',

  contratacionesTraerEstadosLegalesStart: '[contrataciones] Start Traer Estados Legales usuario',
  contratacionesTraerEstadosLegalesError: '[contrataciones] Traer Estados Legales usuario Error',
  contratacionesTraerEstadosLegalesSuccess: '[contrataciones] Traer Estados Legales usuario Exitoso',

  contratacionesTraerAreasLegalesStart: '[contrataciones] Start Tipos Areas Legales usuario',
  contratacionesTraerAreasLegalesError: '[contrataciones] Traer  Areas Legales usuario Error',
  contratacionesTraerAreasLegalesSuccess: '[contrataciones] Traer  Areas Legales usuario Exitoso',

  contratacionesContratoLimpiarSeleccion:
    '[contrataciones] Limpiar Seleccion Contrato',
  contratacionesConsultaLimpiarSeleccion:
    '[contrataciones] Limpiar Seleccion de Contrato consulta',
  contratacionesContratoNuevoLimpiarSeleccion:
    '[contrataciones] Limpiar Seleccion de Contrato nuevo',

  contratacionesContratoSeleccionado: '[contrataciones] Seleccion Contrato',

  contratacionesSetDataContrato: '[contrataciones] Set data contrato',
  contratacionesTraerPorCUITStart:
    '[contrataciones] Start Traer Datos Por CUIT',
  contratacionesTraerPorCUITSuccess:
    '[contrataciones] Traer Datos Por CUIT Exitoso',
  contratacionesTraerPorCUITError:
    '[contrataciones] Traer Datos Por CUIT Error',
  consultaTraerContratoPorCuit: '[contrataciones] traer Contrato por Cuit',

  traerContratosRedStart: '[contrataciones] Start Traer Contratos Red',
  traerContratosRedSuccess: '[contrataciones] Traer Contratos Red Exitoso',
  traerContratosRedError: '[contrataciones] Traer Contratos Red Error',

  traerPrestadoresFiltradosStart: '[contrataciones] Start Traer Prestadores Filtrados',
  traerPrestadoresFiltradosSuccess: '[contrataciones] Start Traer Prestadores Filtrados Exitoso',
  traerPrestadoresFiltradosError: '[contrataciones] Start Traer Prestadores Filtrados Error',

  traerPracticaStart: '[contrataciones] Start Traer Practica',
  traerPracticaSuccess: '[contrataciones] Start Traer Practica Exitoso',
  traerPracticaError: '[contrataciones] Start Traer Practica Error',
  CleanPractica: '[contrataciones] Clean Practica',

  contratacionesGuardarContrato: '[contrataciones] Guardar Contrato',
  contratacionesNuevaContratacionStep:
    '[contrataciones] guardar NuevaContratacionStep',
  contratacionesGuardarContactoNuevo: '[contrataciones] Cargar Contacto nuevo',

  contratacionesTipoEfectoresTraerStart: '[contrataciones] Start Traer Tipo Efectores',
  contratacionesTipoEfectoresTraerError: '[contrataciones] Traer Tipo Efectores Error',
  contratacionesTipoEfectoresTraerSuccess: '[contrataciones] Traer Tipo Efectores Exitoso',

  contracionesSetNuevoContacto: '[contrataciones] Setear nuevo contacto',
  contracionesResetNuevoContacto: '[contrataciones] Reset nuevo contacto',
  contratacionesSetearContactoEditDelete:
    '[contrataciones] Setea el contacto a editar/eliminar',

  contratacionesOpenDeleteConfirmModalEfector:
    '[contrataciones] Open delete modal contactos',
  contratacionesOpenCreateEditModalEfector:
    '[contrataciones] Open create/edit contactos',

  contratacionesTraerBancosStart: '[contrataciones] Get Bancos start',
  contratacionesTraerBancosSuccess: '[contrataciones] Get Bancos success',
  contratacionesTraerBancosError: '[contrataciones] Get Bancos error',

  contratacionesTraerCategoriasStart: '[contrataciones] Get Categorias start',
  contratacionesTraerCategoriasSuccess:
    '[contrataciones] Get Categorias success',
  contratacionesTraerCategoriasError: '[contrataciones] Get Categorias error',

  contratacionIvaTraerStart: '[contrataciones] Get Iva start',
  contratacionIvaTraerSuccess: '[contrataciones] Get Iva success',
  contratacionIvaTraerError: '[contrataciones] Get Iva error',

  contratacionesCuentasClean: '[contrataciones] Get Cuentas clean',
  contratacionesTraerCuentasStart: '[contrataciones] Get Cuentas start',
  contratacionesTraerCuentasSuccess: '[contrataciones] Get Cuentas success',
  contratacionesTraerCuentasError: '[contrataciones] Get Cuentas error',
  contratacionesCuentasGuardar: '[contrataciones] Get Cuentas Guardar',
  contratacionesCuentasActualizar: '[contrataciones] Get Cuentas Actualizar',
  contratacionesCuentasEliminar: '[contrataciones] Get Cuentas Eliminar',

  contratacionesCuentaJudicialGet: '[contrataciones] Get Cuenta Judicial Get',
  contratacionesCuentaJudicialClean: '[contrataciones] Get Cuenta Judicial Clean',
  contratacionesCuentaJudicialSave: '[contrataciones] Get Cuenta Judicial Save',

  contratacionesSetearDatosContables: '[contrataciones] Set State Datos Contables',

  contratacionesSetDocumentacionCargada: '[contrataciones] Set Documentación cargada',
  contratacionesGetDocumentacionXSubTipoEfector: '[contrataciones] Get Documentación x SubTipoEfector',
  contratacionesGetDocumentacionEF: '[contrataciones] Get Documentación Efector Facturación',
  contratacionesGetDocumentacionLegal: '[contrataciones] Get Documentación Legal',

  contratacionesTraerCartillaPrestadoresSuccess: '[contrataciones] Get Cartilla Prestadores de Red Success',
  contratacionesTraerCartillaPrestadoresError: '[contrataciones] Get Cartilla Prestadores de Red Error',
  contratacionesGetRubrosSuccess: '[contrataciones] Get Rubros Success',
  contratacionesGetRubrosError: '[contrataciones] Get Rubros Error',
  contratacionesGetZonasSuccess: '[contrataciones] Get Zonas Success',
  contratacionesGetZonasError: '[contrataciones] Get Zonas Error',
  contratacionesGetCentrosMedicosSuccess: '[contrataciones] Get Centros Medicos Success',
  contratacionesGetCentrosMedicosError: '[contrataciones] Get Centros Medicos Error',
  contratacionesGetRankingsCartillaSuccess: '[contrataciones] Get Rankings|Cartilla Success',
  contratacionesGetRankingsCartillaError: '[contrataciones] Get Rankings|Cartilla Error',
  contratacionesGetCartillaSuccess: '[contrataciones] Get Cartilla Success',
  contratacionesGetCartillaError: '[contrataciones] Get Cartilla Error',
  contratacionesGetPlanesSuccess: '[contrataciones] Get Planes Success',
  contratacionesGetPlanesError: '[contrataciones] Get Planes Error',
  contratacionesGetPlanesCuentasSuccess: '[contrataciones] Get Planes Cuentas Success',
  contratacionesGetPlanesCuentasError: '[contrataciones] Get Planes Cuentas Error',
  contratacionesGetCategoriasSuccess: '[contrataciones] Get Categorias Success',
  contratacionesGetCategoriasError: '[contrataciones] Get Categorias Error',

  contratacionesCuentasNomenclador: '[contrataciones] GET CuentasNomenclador',
  contratacionesCuentasNomencladorSuccess: '[contrataciones] GET CuentasNomenclador Success',
  contratacionesCuentasNomencladorError: '[contrataciones] GET CuentasNomenclador Error',
  contratacionesCuentasNomencladorGuardar: '[contrataciones] POST CuentasNomenclador Error',
  contratacionesCuentasNomencladorModificar: '[contrataciones] PUT CuentasNomenclador Error',
  contratacionesCuentasNomencladorEliminar: '[contrataciones] DELETE CuentasNomenclador Error',

  contratacionesContratoLimpiarConvenios: '[contrataciones] Limpiar Convenios Contrato',
  contratacionesConveniosGetPorPracticaSuccess: '[contrataciones] GET Convenios por Practicas Success',
  contratacionesConveniosGetPorPracticaError: '[contrataciones] GET Convenios por Practicas Error',
  contratacionesConveniosTraerCapitulos: '[contrataciones] GET Capitulos',
  contratacionesConveniosPrevisualizacionSuccess: '[contrataciones] POST Previsualizacion Success',
  contratacionesConveniosPrevisualizacionError: '[contrataciones] POST Previsualizacion Error',
  contratacionesConveniosGetPracticasConfirmadasSuccess: '[contrataciones] GET PracticasConfirmadas Success',
  contratacionesConveniosGetPracticasConfirmadasError: '[contrataciones] GET PracticasConfirmadas Error',
  contratacionesConveniosPracticasConfirmadasSuccess: '[contrataciones] POST PracticasConfirmadas Success',
  contratacionesConveniosPracticasConfirmadasError: '[contrataciones] POST PracticasConfirmadas Error',
  contratacionesConveniosValorFijoGetPracticasSuccess: '[contrataciones] GET Valor Fijo Practicas Success',
  contratacionesConveniosValorFijoGetPracticasError: '[contrataciones] GET Valor Fijo Practicas Error',
  contratacionesConveniosValorFijoGetPracticasActivasSuccess: '[contrataciones] GET Valor Fijo Practicas Activas Success',
  contratacionesConveniosValorFijoGetPracticasActivasError: '[contrataciones] GET Valor Fijo Practicas Activas Error',
  contratacionesConveniosNNXGetPracticasSuccess: '[contrataciones] GET NNX Practicas Success',
  contratacionesConveniosNNXGetPracticasError: '[contrataciones] GET NNX Practicas Error',
  contratacionesConveniosNNXGetPracticasActivasSuccess: '[contrataciones] GET NNX Practicas Activas Success',
  contratacionesConveniosNNXGetPracticasActivasError: '[contrataciones] GET NNX Practicas Activas Error',
  contratacionesConveniosNBUGetPracticasSuccess: '[contrataciones] GET NBU Practicas Success',
  contratacionesConveniosNBUGetPracticasError: '[contrataciones] GET NBU Practicas Error',
  contratacionesConveniosNBUGetPracticasActivasSuccess: '[contrataciones] GET NBU Practicas Activas Success',
  contratacionesConveniosNBUGetPracticasActivasError: '[contrataciones] GET NBU Practicas Activas Error',
  contratacionesConveniosPrestadoresPorPracticas: '[contrataciones] GET Prestadores Por Practicas',
  contratacionesConveniosPrestadoresPorPracticasSuccess: '[contrataciones] GET Prestadores Por Practicas Success',
  contratacionesConveniosPrestadoresPorPracticasError: '[contrataciones] GET Prestadores Por Practicas Error',
  contratacionesConveniosModulosGetActivosSuccess: '[contrataciones] GET Modulos Activos Success',
  contratacionesConveniosModulosGetActivosError: '[contrataciones] GET Modulos Activos Error',
  contratacionesConveniosModulosCargaSuccess: '[contrataciones] GET Modulos Carga Success',
  contratacionesConveniosModulosCargaError: '[contrataciones] GET Modulos Carga Error',
  contratacionesConveniosPresupuestosGetActivosSuccess: '[contrataciones] GET Presupuestos Activos Success',
  contratacionesConveniosPresupuestosGetActivosError: '[contrataciones] GET Presupuestos Activos Error',
  contratacionesGetTrackingPresupuestoSuccess: '[contrataciones] Get Tracking Presupuesto Success',
  contratacionesGetTrackingPresupuestoError: '[contrataciones] Get Tracking Presupuesto Error',
  contratacionesConveniosSetActivosPorFecha: '[contrataciones] SET Activos Por Fecha',
  contratacionesConveniosEquivalenciasNomencladoresGetSuccess: '[contrataciones] GET EquivalenciasNomencladores Success',
  contratacionesConveniosEquivalenciasNomencladoresGetError: '[contrataciones] GET EquivalenciasNomencladores Error',

  contratacionesAcuerdoJudicialSet: '[contrataciones] GET ContratacionesAcuerdoJudicial Set',

  contratacionesNomenclador: '[contrataciones] GET Nomenclador',
  contratacionesNomencladorSuccess: '[contrataciones] GET Nomenclador Success',
  contratacionesNomencladorIntegracionSuccess: '[discapacidad] GET Nomenclador Integracion Success',
  contratacionesNomencladorError: '[contrataciones] GET Nomenclador Error',
  contratacionesNomencladorGuardar: '[contrataciones] POST Nomenclador Error',
  contratacionesNomencladorModificar: '[contrataciones] PUT Nomenclador Error',

  contratacionesSetearInclusionesExclusiones: '[contrataciones] Set Inclusiones Exclusiones',
  contratacionesLimpiarInclusionesExclusiones: '[contrataciones] Limpiar Inclusiones Exclusiones',

  traerModulosPorContratoStart:
    '[contrataciones] Get Modulos Por Contrato start',
  traerModulosPorContratoSuccess:
    '[contrataciones] Get Modulos Por Contrato success',
  traerModulosPorContratoError:
    '[contrataciones] Get Modulos Por Contrato error',

  coseguroGetPracticasSuccess: '[coseguro] GET Practicas Success',
  coseguroGetPracticasError: '[coseguro] GET Practicas Error',
  coseguroVaciarPracticas: '[coseguro] Vaciar Practicas',
  coseguroGetBuscadorPracticasSuccess:
    '[coseguro] GET Buscador Practicas Success',
  coseguroGetBuscadorPracticasError: '[coseguro] GET Buscador Practicas Error',
  coseguroResetBuscadorPracticas: '[coseguro] Reset Buscador Practicas',
  coseguroAddPractica: '[coseguro] Add Practica',
  coseguroGetValorizacionesSuccess: '[coseguro] GET Valorizaciones Success',
  coseguroGetValorizacionesError: '[coseguro] GET Valorizaciones Error',
  coseguroResetValorizaciones: '[coseguro] Reset Valorizaciones',

  ctaCteGetTurnosSuccess: '[ctaCte] Get Turnos Success',
  ctaCteGetTurnosError: '[ctaCte] Get Turnos Error',
  ctaCteGetTurnosSaldoSuccess: '[ctaCte] Get Turnos Saldo Success',
  ctaCteGetTurnosSaldoError: '[ctaCte] Get Turnos Saldo Error',
  ctaCteGetDetalleComprobanteSuccess:
    '[ctaCte] Get Detalle Comprobante Success',
  ctaCteGetDetalleComprobanteError: '[ctaCte] Get Detalle Comprobante Error',
  ctaCteGetTurnoValorizacionSuccess: '[ctaCte] Get Turno Valorizacion Success',
  ctaCteGetTurnoValorizacionError: '[ctaCte] Get Turno Valorizacion Error',

  abmUsuarioPorIdProfesionalSuccess: '[abmUsuarioPorIdProfesional] Get Abm Usuario Por Id Profesional Success',
  abmUsuarioPorIdProfesionalError: '[abmUsuarioPorIdProfesional] Get Abm Usuario Por Id Profesional Error',
  abmSetUsuarioPorIdProfesional: '[abmUsuarioPorIdProfesional] Set Abm Usuario Por Id Profesional',
  abmUsuarioPorIdProfesionalLimpiar: '[abmUsuarioPorIdProfesional] Limpiar Abm Usuario Por Id Profesional',

  especialidadesTraer: '[Especialidades] Start Traer Especialidades',
  especialidadesTraerError: '[Especialidades] Traer Especialidades Error',
  especialidadesTraerSucces: '[Especialidades] Traer Especialidades Exitoso',
  especialidadesProfesionalTraer: '[Especialidades Profesional] Start Traer Especialidades',
  especialidadesProfesionalTraerError: '[Especialidades Profesional] Traer Especialidades Error',
  especialidadesProfesionalTraerSucces: '[Especialidades Profesional] Traer Especialidades Exitoso',
  centrosPropiosProfesionalTraer: '[Centros Propios Profesional] Start Traer Centros',
  centrosPropiosProfesionalTraerError: '[Centros Propios Profesional] Traer Centros Error',
  centrosPropiosProfesionalTraerSucces: '[Centros Propios Profesional] Traer Centros Exitoso',

  abmEspecialidadTraerStart: '[abmEspecialidad] Start Traer Especialidad',
  abmEspecialidadTraerError: '[abmEspecialidad] Traer Especialidad Error',
  abmEspecialidadTraerSuccess: '[abmEspecialidad] Traer Especialidad Exitoso',
  abmEspecialidadBuscar: '[abmEspecialidad] Buscar Especialidad',

  abmTraerTopesMinimosStart: '[abmTopesMinimos]  trae los topes minimos',
  abmTraerTopesMinimosSuccess: '[abmTopesMinimos] Traida de los topes minimos Success',
  abmTraerTopesMinimosError: '[abmTopesMinimos] Traida de los  topes minimos Error',
  abmBuscarTopesMinimos: '[abmTopesMinimos]  Filtrar los topes minimos',
  abmModificarTopesMinimos: '[abmTopesMinimos] Modificar los topes minimos',

  abmTraerMotivosBajaStart: '[abmMotivosBaja]  trae los motivos de baja de los efectores',
  abmTraerMotivosBajaSuccess: '[abmMotivosBaja]  Traida de los motivos de baja de los efectores Success',
  abmMotivosBajaError: '[abmMotivosBaja]  Traida de los motivos de baja de los efectores Error',
  abmBuscarMotivosBaja: '[abmMotivosBaja]   Filtrar los motivos de baja de los efectores',
  abmModificarMotivosBaja: '[abmMotivosBaja]  Modificar los motivos de baja de los efectores',

  abmTraerPlazosSuccess:
    '[abmMotivosBaja]  Traida de los plazos de los efectores Success',
  abmBuscarPlazos: '[abmMotivosBaja]   Filtrar los plazos de los efectores',

  abmModulosTraerStart: '[abmModulos]  trae los modulos',
  abmModulosTraerSuccess: '[abmModulos]  Traida de los modulos Success',
  abmModulosTraerError: '[abmModulos]  Traida de los modulos Error',

  abmCosegurosTraerStart: '[abmCoseguros]  trae los coseguros',
  abmCosegurosTraerSuccess: '[abmCoseguros]  Traida de los coseguros Success',
  abmCosegurosTraerError: '[abmCoseguros]  Traida de los coseguros Error',

  abmCosegurosPracticasTraerSuccess: '[abmCoseguros]  Traida de practicas de los coseguros Success',
  abmCosegurosPracticasTraerError: '[abmCoseguros]  Traida de practicas de los coseguros Error',
  abmCosegurosPracticasClean: '[abmCoseguros]  Limpia resultados de practicas coseguros',

  tipoEfectoresTraerStart: '[tipoEfectores] Start Traer tipoEfectores',
  tipoEfectoresTraerError: '[tipoEfectores] Traer tipoEfectores Error',
  tipoEfectoresTraerSuccess: '[tipoEfectores] Traer tipoEfectores Exitoso',
  subtipoEfectoresTraerStart: '[subtipoEfectores] Start Traer subtipoEfectores',
  subtipoEfectoresTraerError: '[subtipoEfectores] Traer subtipoEfectores Error',
  subtipoEfectoresTraerSuccess: '[subtipoEfectores] Traer subtipoEfectores Exitoso',

  tipoDocumentacionPorSubTipoEfectorLimpiar:
    '[Tipo Docu SubTipoEfector] Limpiar',
  tipoDocumentacionPorSubTipoEfector: '[Tipo Docu SubTipoEfector] Traer',
  tipoDocumentacionPorSubTipoEfectorTraerSuccess:
    '[Tipo Docu SubTipoEfector] Traer success',
  tipoDocumentacionPorSubTipoEfectorTraerError:
    '[Tipo Docu SubTipoEfector] Traer error',
  tipoDocumentacionPorSubTipoEfectorModificar:
    '[Tipo Docu SubTipoEfector] Modificar',
  tipoDocumentacionPorSubTipoEfectorCrear: '[Tipo Docu SubTipoEfector] Crear',
  tipoDocumentacionPorSubTipoEfectorEliminar:
    '[Tipo Docu SubTipoEfector] Eliminar',

  abmMedicosTraerStart: '[abmMedicos] Start Traer Datos',
  abmMedicosTraerError: '[abmMedicos] Traer Datos Error',
  abmMedicosTraerSuccess: '[abmMedicos] Traer Datos Exitoso',
  abmMedicosTraerPorCUITStart: '[abmMedicos] Start Traer Datos Por CUIT',
  abmMedicosTraerPorCUITSuccess: '[abmMedicos] Traer Datos Por CUIT Exitoso',
  abmMedicosTraerPorCUITError: '[abmMedicos] Traer Datos Por CUIT Error',
  abmMedicosConsultaLimpiarSeleccion: '[abmMedicos] Limpiar Seleccion de MédicoABM consulta',
  abmMedicosLimpiarSeleccion: '[abmMedicos] Limpiar Seleccion MédicoABM',
  abmMedicosNuevoMedicoStep: '[abmMedicos] guardar NuevoMedicoStep',
  abmMedicosNuevoLimpiarSeleccion: '[abmMedicos] Limpiar Seleccion de MédicoABM nuevo',
  abmMedicosGuardarMedicoNuevo: '[abmMedicos] Guardar Medico Nuevo',
  abmMedicosSeleccionado: '[abmMedicos] Medico Seleccionado',
  limpiarMedicosAbm: '[abmMedicos] Limpiar',
  setOrDeleteCMProfesional: '[abmMedicos] Setear o eliminar CM del Profesional',
  setOrDeleteCMProfesionalSuccess: '[abmMedicos] Setear o eliminar CM del Profesional Success',
  setOrDeleteCMProfesionalError: '[abmMedicos] Setear o eliminar CM del Profesional Error',
  setOrDeleteEspecialidadProfesional: '[abmMedicos] Setear o eliminar Especialidad del Profesional',
  setOrDeleteEspecialidadProfesionalSuccess: '[abmMedicos] Setear o eliminar Especialidad del Profesional Success',
  setOrDeleteEspecialidadProfesionalError: '[abmMedicos] Setear o eliminar Especialidad del Profesional Error',

  seccionalesTraerStart: '[seccionales] Start Traer Datos',
  seccionalesTraerSuccess: '[seccionales] Traer Datos Exitoso',
  seccionalesTraerError: '[seccionales] Traer Datos Error',
  seccionalesBuscar: '[Seccionales] Filtrar las Seccionales',
  seccionalesModificar: '[Seccionales] Modificar Seccional',
  seccionalesEliminar: '[Seccionales] Eliminar Seccional',
  seccionalesAgregar: '[Seccionales] Agregar Seccional',
  seccionalesAltasSuccess: '[seccionales] Traer Datos Altas Exitoso',
  seccionalesAltasDiscaSuccess: '[seccionales] Traer Datos Altas Disca Exitoso',

  localidadesTraerStart: '[localidades] Start Traer Datos',
  localidadesTraerSuccess: '[localidades] Traer Datos Exitoso',
  localidadesTraerError: '[localidades] Traer Datos Error',

  medioPagoTraerStart: '[medio Pago] Start Traer Datos',
  medioPagoTraerSuccess: '[medio Pago] Traer Datos Exitoso',
  medioPagoTraerError: '[medio Pago] Traer Datos Error',

  loginUserAutoGestion: '[Autogestion] loguea usuario Externo',

  provinciasTraerStart: '[provincias] Start Traer Datos',
  provinciasTraerSuccess: '[provincias] Traer Datos Exitoso',
  provinciasTraerError: '[provincias] Traer Datos Error',

  categoriasTraerStart: '[categorias] Start Traer Datos',
  categoriasTraerSuccess: '[categorias] Traer Datos Exitoso',
  categoriasTraerError: '[categorias] Traer Datos Error',

  motivosBajaTraerSucces: '[motivosBaja] Traer Datos Exitoso',
  motivosBajaTraerError: '[motivosBaja] Traer Datos Error',


  configuracionPorCategoriaTraerStart: '[configuracion categorias] Start Traer Datos',
  configuracionPorCategoriaTraerError: '[configuracion categorias] error Traer Datos',
  configuracionPorCategoriaTraerSuccess: '[configuacion categorias] succes Traer Datos',
  configuracionCategoriaLimpiar: '[configuacion categorias] Limpiar  Datos',

  conveniosPrestacionalesTraerStart: '[convenios prestacionales] Start Traer Datos',
  conveniosPrestacionalesTraerSuccess: '[convenios prestacionales] Traer Datos Exitoso',
  conveniosPrestacionalesTraerError: '[convenios prestacionales] Traer Datos Error',

  contactosWebTraerStart: '[contactos web] Start Traer Datos',
  contactosWebTraerSuccess: '[contactos web] Traer Datos Exitoso',
  contactosValidos: '[contactos web validos] Traer Datos Exitoso',
  contactosPendientes: '[contactos web pendientes] Traer Datos Exitoso',
  buscarContactosWeb: '[Buscar contactos web] Traer Datos Exitoso',
  contactosWebTraerError: '[contactos web] Traer Datos Error',


  planesTraerStart: '[planes prestacionales] Start Traer Datos',
  planesTraerSuccess: '[planes prestacionales] Traer Datos Exitoso',
  planesTraerError: '[planes prestacionales] Traer Datos Error',

  parentescosTraerStart: '[parentescos prestacionales] Start Traer Datos',
  parentescosTraerSuccess: '[parentescos prestacionales] Traer Datos Exitoso',
  parentescosTraerError: '[parentescos prestacionales] Traer Datos Error',

  registroUserSuccess: '[Registro movimientosUserTraerSuccessimiento] insertar Datos User',

  empresaTraerAFIPStart: '[empresa] Start Traer Datos AFIP',
  empresaTraerAFIPSuccess: '[empresa] Traer Datos AFIP Exitoso',
  empresaTraerAFIPError: '[empresa] Traer Datos AFIP Error',
  empresaTraerPorCUITStart: '[empresa] Start Traer Datos Por CUIT',
  empresaTraerPorCUITSuccess: '[empresa] Traer Datos Por CUIT Exitoso',
  empresaTraerPorCUITError: '[empresa] Traer Datos Por CUIT Error',
  empresaUpdateStart: '[empresa] Start Empresa Update',
  empresaUpdateError: '[empresa] Error en Empresa Update',
  empresaUpdated: '[empresa] Updated',
  empresaLimpiar: '[empresa] Limpiar',
  empresaInsertSuccess: '[empresa] Insert Empresa Start',
  empresaInsertStart: '[empresa] Insert Empresa Exitosa',
  empresaInsertError: '[empresa] Insert Empresa Error',

  // MI OSPEDYC: ESTADISTICAS
  estadisticasMiOspedycGeneralesTraerStart:
    '[estadisticasMiOspedycGenerales] Start Traer Datos',
  estadisticasMiOspedycGeneralesTraerSuccess:
    '[estadisticasMiOspedycGenerales] Traer Datos Exitoso',
  estadisticasMiOspedycGeneralesTraerError:
    '[estadisticasMiOspedycGenerales] Traer Datos Error',
  estadisticasMiOspedycUsuariosTraerStart:
    '[estadisticasMiOspedycUsuarios] Start Traer Datos',
  estadisticasMiOspedycUsuariosTraerSuccess:
    '[estadisticasMiOspedycUsuarios] Traer Datos Exitoso',
  estadisticasMiOspedycUsuariosTraerError:
    '[estadisticasMiOspedycUsuarios] Traer Datos Error',
  estadisticasMiOspedycTurnosTraerStart:
    '[estadisticasMiOspedycTurnos] Start Traer Datos',
  estadisticasMiOspedycTurnosTraerSuccess:
    '[estadisticasMiOspedycTurnos] Traer Datos Exitoso',
  estadisticasMiOspedycTurnosTraerError:
    '[estadisticasMiOspedycTurnos] Traer Datos Error',
  //MI OSPEDYC: CARTILLA
  cartillaMiOspedycTraerStart: '[cartillaMiOspedyc] Start Traer Datos',
  cartillaMiOspedycTraerSuccess: '[cartillaMiOspedyc] Traer Datos Exitoso',
  cartillaMiOspedycTraerError: '[cartillaMiOspedyc] Traer Datos Error',
  miCartillaMiOspedycTraerStart: '[miCartillaMiOspedyc] Start Traer Datos',
  miCartillaMiOspedycTraerSuccess: '[miCartillaMiOspedyc] Traer Datos Exitoso',
  miCartillaMiOspedycTraerError: '[miCartillaMiOspedyc] Traer Datos Error',

  afiliadoTraerAFIPStart: '[afiliado] Start Traer Datos AFIP',
  afiliadoTraerAFIPSuccess: '[afiliado] Traer Datos AFIP Exitoso',
  afiliadoTraerAFIPError: '[afiliado] Traer Datos AFIP Error',

  afiliadoReactivacionValidarDatosPersonalesTraerStart:
    '[afiliadoReactivacion] Start Traer Validar Datos Personales',
  afiliadoReactivacionValidarDatosPersonalesTraerSuccess:
    '[afiliadoReactivacion] Validar Datos Personales Traer Exitoso',
  afiliadoReactivacionValidarDatosPersonalesTraerError:
    '[afiliadoReactivacion] Validar Datos Personales Traer Error',

  traerDataPersonalStart: '[Afiliado-DataPersonal] Traer DataPersonal start',
  traerDataPersonalSuccess:
    '[Afiliado-DataPersonal] Traer DataPersonal success',
  traerDataPersonalError: '[Afiliado-DataPersonal] Traer DataPersonal error',

  afiliadoReactivacionSeleccionado:
    '[afiliadoReactivacion] Seleccion afiliadoReactivacion',
  afiliadoReactivacionLimpiarSeleccion:
    '[afiliadoReactivacion] Limpiar Seleccion afiliadoReactivacion',

  tipoDocumentacionParentescoTraerStart:
    '[Tipo Docu] Parentesco Start Traer Datos',
  tipoDocumentacionParentescoTraerSuccess:
    '[Tipo Docu] Parentesco Traer Datos Exitoso',
  tipoDocumentacionParentescoTraerError:
    '[Tipo Docu] Parentesco Traer Datos Error',


  tipoDocumentacionTipoAfiliacionTraerStart: '[Tipo Docu] Tipo Afiliacion Start Traer Datos',
  tipoDocumentacionTipoAfiliacionTraerSuccess: '[Tipo Docu] Tipo Afiliacion Traer Datos Exitoso',
  tipoDocumentacionTipoAfiliacionTraerError: '[Tipo Docu] Tipo Afiliacion Traer Datos Error',

  tipoDocumentacionPorTipoAfilacion: '[Tipo Docu] Tipo Afilacion Traer Datos por Afiliacion',
  tipoDocumentacionPorTipoAfilacionTraerStart: '[Tipo Docu] Tipo Afilacion Traer Datos por Afiliacion Start',
  tipoDocumentacionPorTipoAfilacionTraerError: '[Tipo Docu] Tipo Afilacion Traer Datos por Afiliacion Error',

  tipoDocumentacionPorTipoAfilacionObligatorioModificado: '[Tipo Docu] Tipo Afilacion modifico Documento',
  tipoDocumentacionPorTipoAfilacionEliminar: '[Tipo Docu] Tipo Afilacion Elimino  Documento',
  tipoDocumentacionPorTipoAfilacionNuevo: '[Tipo Docu] Tipo Afilacion Se crea Documento',
  tipoDocumentacionPorTipoAfilacionModificado: '[Tipo Docu] Tipo Afilacion Se modifica Documento',

  configuracionLimpiar: '[Configuracion] Limpiar',

  tipoDocumentacionPorTipoParentescoObligatorioModificado:
    '[Tipo Docu] Tipo Parentesco modifico Documento',
  tipoDocumentacionPorTipoParentescoNuevo:
    '[Tipo Docu] Tipo Parentesco Se crea Documento',
  tipoDocumentacionTipoParentescoEliminar:
    '[Tipo Docu] Tipo Parentesco Elimino Documento',

  documentacionSubidaStart: '[Documentacion] Subida Docu Start',
  documentacionSubidaSuccess: '[Documentacion] Subida Docu Exitosa',
  documentacionSubidaError: '[Documentacion] Subida Docu Error',

  grupoFamiliarTraerStart: '[Grupo Familiar] Traer Start',
  grupoFamiliarTraerSuccess: '[Grupo Familiar] Traer Exitoso',
  grupoFamiliarTraerError: '[Grupo Familiar] Traer Error',
  grupoFamiliarLimpiar: '[Grupo Familiar] Limpiar',
  familiarSeleccionadoAfiliado: '[ Familiar] selecciona el familiar de afiliado',

  grupoFamiliarPreinscriptoTraerStart: '[Grupo Familiar Preinscripto] Traer Start',
  grupoFamiliarPreinscriptoTraerSuccess: '[Grupo Familiar Preinscripto] Traer Exitoso',
  grupoFamiliarPreinscriptoTraerError: '[Grupo Familiar Preinscripto] Traer Error',
  grupoFamiliarPreinscriptoLimpiar: '[Grupo Familiar Preinscripto] Limpiar',
  grupoFamiliarPreinscriptoSeleccion: '[Grupo Familiar Preinscripto] Selecion',
  grupoFamiliarStagePreinscriptoSeleccion: '[Grupo Familiar Preinscripto stage] Selecion',
  grupoFamiliarLimpiarSeleccionado: '[Grupo Familiar Preinscripto] Limpiar Seleccion',
  grupoFamiliarPreinscriptoDeleteFamiliar: '[Grupo Familiar Preinscripto] eliminar familiar de preinscripto',
  documentacionFamiliarPreafiliadoChange: '[Grupo Familiar Preinscripto] estado documentacion Seleccion',
  grupoFamiliarSetTab: '[Grupo Familiar Preinscripto] set Tab',

  seleccionarEmpresaABM: '[Empresa ABM] Seleccion Empresa',
  desSeleccionarEmpresaABM: '[Empresa ABM] Desseleccionar Empresa',
  updateStoreEmpresaABM: '[Empresa ABM] Actualizar o Almacenar Empresa',
  empresasAfiliadoTraerStart: '[Empresas Afiliado] Traer Start',
  empresasAfiliadoTraerSuccess: '[Empresas Afiliado] Traer Exitoso',
  empresasAfiliadoTraerError: '[Empresas Afiliado] Traer Error',
  empresasAfiliadoLimpiar: '[Empresas Afiliado] Limpiar',
  empresasAfiliadoStartUpdate: '[Empresas Afiliado] Start Update',
  empresasAfiliadoUpdated: '[Empresas Afiliado]  Updated',
  empresasAfiliadoStart: '[Empresas Afiliado] Insert Empresa Afiliado Start',
  empresasAfiliadoInsertSuccess: '[Empresas Afiliado] Insert Empresa Afiliado Exitosa',
  empresasAfiliadoDeleted: '[Empresas Afiliado] Eliminar Empresa del afiliado',

  empresasPreafiliadoTraerStart: '[Empresas Preafiliado] Traer Start',
  empresasPreafiliadoTraerSuccess: '[Empresas Preafiliado] Traer Exitoso',
  empresasPreafiliadoTraerError: '[Empresas Preafiliado] Traer Error',
  empresasPreafiliadoLimpiar: '[Empresas Preafiliado] Limpiar',
  empresasPreafiliadoStartUpdate: '[Empresas Preafiliado] Start Update',
  empresasPreafiliadoUpdated: '[Empresas Preafiliado]  Updated',
  empresasPreafiliadoStart:
    '[Empresas Preafiliado] Insert Empresa Preafiliado Start',
  empresasPreafiliadoInsertSuccess:
    '[Empresas Afiliado] Insert Empresa Afiliado Exitosa',
  empresasPreafiliadoDeleted: '[Empresas Preafiliado]  Deleted',

  observacionesTraerStart: '[Observaciones] Traer Start',
  observacionesTraerSuccess: '[Observaciones] Traer Exitoso',
  observacionesTraerError: '[Observaciones] Traer Error',
  observacionesLimpiar: '[Observaciones] Limpiar',
  observacionesInsertStart: '[Observaciones] Insert Observ. Start',
  observacionesInsertSuccess: '[Observaciones] Insert Observ. Exitosa',
  observacionesInsertError: '[Observaciones] Insert Observ. Error',
  observacionesDeleted: '[Observaciones] Delete Observ. Success',

  observacionesPreafiliadosTraerStart: '[ObservacionesPreafiliado] Traer Start',
  observacionesPreafiliadosTraerSuccess: '[ObservacionesPreafiliado] Traer Exitoso',
  observacionesPreafiliadosTraerError: '[ObservacionesPreafiliado] Traer Error',
  observacionesPreafiliadosLimpiar: '[Observaciones Preafiliado] Limpiar',
  // documentacionActualizarStart: '[Documentacion] Actualizar Docu Start',
  documentacionStartUpdate: '[Documentacion] Start Docu Update',
  documentacionUpdated: '[Documentacion] Updated documento',
  documentacionDelete: '[Documentacion] Delete Documentacion',
  documentacionDeleteError: '[Documentacion] Delete Documentacion Error',
  documentacionActualizarError: '[Documentacion] Actualizar Docu Error',

  documentacionTraerCargadaStart: '[Documentacion] Traida de Docu Afiliado Start',
  documentacionTraerCargadaSuccess: '[Documentacion] Traida de Docu Afiliado Success',
  documentacionTraerCargadaError: '[Documentacion] Traida de Docu Afiliado Error',
  documentacionLimpiarLista: '[Documentacion] Limpia Docu Afiliado',

  documentacionCargadaTitularTraerCargadaStart:
    '[Documentacion Presentada Titular] Traida de Docu Cargada Titular Start',
  documentacionCargadaTitularTraerCargadaSuccess:
    '[Documentacion Presentada Titular] Traida de Docu Cargada Titular Success',
  documentacionCargadaTitularTraerCargadaError:
    '[Documentacion Presentada Titular] Traida de Docu Cargada Titular Error',
  limpiarEstadoDocumentacionCargadaTitular:
    '[Documentacion Presentada Titular] Limpiar  Docu Cargada Titular',

  certificadosCargadaTitularTraerCargadaStart:
    '[Certificado Presentado Titular] Traida de Cert Cargada Titular Start',
  certificadosCargadaTitularTraerCargadaSuccess:
    '[Certificado Presentado Titular] Traida de Cert Cargada Titular Success',
  certificadosCargadaTitularTraerCargadaError:
    '[Certificado Presentado Titular] Traida de Cert Cargada Titular Error',
  limpiarEstadoCertificadosCargadaTitular:
    '[Certificado Presentado Titular] Limpiar  Cert Cargada Titular',

  documentacionCargadaFamiliaresTraerCargadaStart:
    '[Documentacion Familiares] Traida de Docu Cargada Familiares Start',
  documentacionCargadaFamiliaresTraerCargadaSuccess:
    '[Documentacion Familiares] Traida de Docu Familiares Success',
  documentacionCargadaFamiliaresTraerCargadaError:
    '[Documentacion Familiares] Traida de Docu Familiares Error',
  limpiarEstadoDocumentacionCargadaFamiliares:
    '[Documentacion Familiares] Limpiar  Docu Cargada Familiares',

  certificadosTraerCargadaStart: '[Certificados] Traida de Certif Afiliado Start',
  certificadosTraerCargadaSuccess: '[Certificados] Traida de Certif Afiliado Success',
  certificadosTraerCargadaError: '[Certificados] Traida de Certif Afiliado Error',
  certificadosLimpiarLista: '[Certificados] Limpia Certif Afiliado',
  certificadosInsertStart: '[Certificados] Insert Certif Start',
  certificadosInsertSuccess: '[Certificados] Insert Certif Exitosa',
  certificadosInsertError: '[Certificados] Insert Certif Error',
  certificadosStartUpdate: '[Certificados] Start Update',
  certificadosUpdated: '[Certificados]  Updated',
  certificadosDelete: '[Certificados]  Delete',
  certificadosImageUploaded: '[Certificados]  Image Uploaded',
  certificadosImageDelete: '[Certificados]  Image Delete',

  aportesTraerStart: '[Aportes] Traida de Aportes Afiliado Start',
  aportesTraerSuccess: '[Aportes] Traida de Aportes Afiliado Success',
  aportesTraerError: '[Aportes] Traida de Aportes Afiliado Error',
  aportesLimpiar: '[Aportes] Limpia Aportes Afiliado',

  aportesPreafiliadoTraerStart: '[AportesPreafiliado] Traida de Aportes Afiliado Start',
  aportesPreafiliadoTraerSuccess: '[AportesPreafiliado] Traida de Aportes Afiliado Success',
  aportesPreafiliadoTraerError: '[AportesPreafiliado] Traida de Aportes Afiliado Error',
  aportesPreafiliadoLimpiar: '[AportesPreafiliado] Limpia Aportes Afiliado',
  aportesPreafiliadoUpdate: '[AportesPreafiliadoUpdate] Limpia Aportes Afiliado',

  usuariosTraerStart: '[Usuarios] Traida de Usuarios Start',
  usuariosTraerSuccess: '[Usuarios] Traida de Usuarios Success',
  usuariosTraerError: '[Usuarios] Traida de Usuarios Error',
  usuariosLimpiar: '[Usuarios] Limpia Usuarios',
  usuariosSeleccionar: '[Usuarios] Set Usuario Seleccionado',
  usuariosSetCentrosMedicos: '[Usuarios] Set Centros Medicos',
  usuariosSeleccionarLimpiar: '[Usuarios] Usuario Seleccionado Limpiar',
  usuariosUpdateUsuarioSeleccionado: '[Usuarios] Update Usuario Seleccionado',
  usuarioNuevo: '[Usuarios] nuevo usuario',
  usuarioTraerYSeleccionarSuccess: '[Usuarios] Traida de Usuario y seleccionar Success',



  rolesTraerStart: '[Roles] Traida de Roles Start',
  rolesTraerSuccess: '[Roles] Traida de Roles Success',
  rolesTraerError: '[Roles] Traida de Roles Error',
  rolesLimpiar: '[Roles] Limpia Roles',
  rolesUsuarioSeleccionado: '[Roles] Traida de Roles Usuario Seleccionado',

  permisosTraerStart: '[Permisos] Traida de Permisos Start',
  permisosTraerSuccess: '[Permisos] Traida de Permisos Success',
  permisosTraerError: '[Permisos] Traida de Permisos Error',
  permisosCategoriasTraerStart: '[Permisos] Traida de Categorias Permisos Start',
  permisosCategoriasTraerSuccess: '[Permisos] Traida de Categorias Permisos Success',
  permisosCategoriasTraerError: '[Permisos] Traida de Categorias Permisos Error',
  permisosLimpiar: '[Permisos] Limpia Permisos',
  permisosRolSeleccionado: '[Permisos] Traida de Permisos Rol Seleccionado',
  permisosSeleccionar: '[Permisos] Seleccionar Permiso',
  permisosGuardar: '[Permisos] Guardar Permiso',
  permisoLimpiar: '[Permiso] Limpiar Permiso',

  areasTraerStart: '[Areas] Traida de Areas Start',
  areasTraerSuccess: '[Areas] Traida de Areas Success',
  areasTraerError: '[Areas] Traida de Areas Error',
  areasLimpiar: '[Areas] Limpia Areas',
  areasUsuarioSeleccionado: '[Areas] Traida de Areas Usuario Seleccionado',
  areasModificarArea: '[Areas] Modificar Area',
  areasAgregar: '[Areas] Agregar Area',
  areasEliminarArea: '[Areas] Eliminar Area',
  areasBuscar: '[Areas] Buscar Area',

  bandejasAutorizacionTraerStart:
    '[bandejasAutorizacion] Traida de bandejas Autorizacion Start',
  bandejasAutorizacionLimpiar:
    '[bandejasAutorizacion] Limpia bandejas Autorizacion',
  bandejasAutorizacionTraerError:
    '[bandejasAutorizacion] Traida de bandejas Autorizacion Error',
  bandejasAutorizacionTraerSuccess:
    '[bandejasAutorizacion] Traida de bandejas Autorizacion Success',
  bandejasUsuarioSeleccionado:
    '[bandejasAutorizacion] Traida de bandejas Autorizacion Usuario Seleccionado',

  subAreasContratacionesTraerStart:
    '[SubAreasContrataciones] Traida de subAreas Contrataciones Start',
  subAreasContratacionesLimpiar:
    '[SubAreasContrataciones] Limpia subAreas Contrataciones',
  subAreasContratacionesTraerError:
    '[SubAreasContrataciones] Traida de subAreas Contrataciones Error',
  subAreasContratacionesTraerSuccess:
    '[SubAreasContrataciones] Traida de subAreas Contrataciones Success',
  subAreasUsuarioSeleccionado:
    '[SubAreasContrataciones] Traida de subAreas Contrataciones Usuario Seleccionado',

  abmMaterialesTraerStart: '[abmMateriales]  trae los materiales',
  abmMaterialesTraerSuccess: '[abmMateriales]  Traida de los materiales Success',
  abmMaterialesTraerError: '[abmMateriales]  Traida de los materiales Error',

  abmRecuperoTraerSuccess: '[abmRecupero]  Traida de los Recupero Success',
  trackingRecuperoTraerSuccess: '[trackingRecupero]  Traida de Tracking Recupero Success',
  recuperoSolicitudTraerSuccess: '[recuperoSolicitud]  Traida de Recupero Solicitud Success',

  spinnerOpen: '[spinner] Open',
  spinnerClose: '[spinner] Close',

  alertaOpen: '[alerta] Open',
  alertaClose: '[alerta] Close',

  abmTraerTipoParentescosStart: '[Parentescos]  trae los tipos de Parentescos',
  abmTraerTipoParentescosSuccess: '[Parentescos] Traida de los tipos de Parentescos Success',
  abmTraerTipoParentescosError: '[Parentescos] Traida de los tipos de Parentescos Error',
  abmBuscarParentescos: '[Parentescos]  Filtrar los tipos de Parentescos',

  abmTraerTipoDocumentaciones: '[Doc]  trae los tipos de documentacion',
  abmEliminarTipodocumentacion: '[Doc]  Elimina los tipos de documentacion',
  abmAgregarTipoDocumentacion: '[Doc]  Agregar los tipos de documentacion',
  abmBuscarDocumentaciones: '[Doc]  Filtrar los tipos de documentacion',

  abmTraerTipoDocumentacionesEfectores: '[Doc]  trae los tipos de documentacion Efectores',
  abmTraerTipoDocumentacionesEfectoresSuccess: '[Doc]  trae los tipos de documentacion Efectores Success',
  abmTraerTipoDocumentacionesEfectoresError: '[Doc]  trae los tipos de documentacion Efectores Error',
  abmFiltrarTipoDocumentacionesEfectores: '[Doc]  trae los tipos de documentacion Efectores Filtrar',

  abmTraerCategorias: '[Doc]  trae las categorias',
  abmEliminarCategoria: '[Doc]  Elimina categoria',
  abmEditarCategoria: '[Doc]  Edita las categorias',
  abmAgregarCategoria: '[Doc]  Agregar Categoria',
  abmBuscarCategoria: '[Doc]  Filtrar categorias',

  get_categorias_formularios: 'get_categorias_formularios',
  get_categorias_formularios_success: 'get_categorias_formularios_success',
  get_categorias_formularios_failure: 'get_categorias_formularios_failure',

  get_formularios_mi_ospedyc: 'get_formularios_mi_ospedyc',
  get_formularios_mi_ospedyc_success: 'get_formularios_mi_ospedyc_success',
  get_formularios_mi_ospedyc_failure: 'get_formularios_mi_ospedyc_failure:',

  get_formulariosporcategoria_mi_ospedyc:
    'get_formulariosporcategoria_mi_ospedyc',
  get_formulariosporcategoria_mi_ospedyc_success:
    'get_formulariosporcategoria_mi_ospedyc_success',
  get_formulariosporcategoria_mi_ospedyc_failure:
    'get_formulariosporcategoria_mi_ospedyc_failure:',

  abmTraerAfiliaciones: '[abmAfiliacion]  traer tipos de Afiliacion',
  abmBuscarAfiliado: '[abmAfiliacion]  Filtrar tipo de Afiliacion',

  abmTraerEstadosCivilesStart: '[EstadoCivil]  trae los tipos de estados civiles',
  abmTraerEstadosCivilesSuccess: '[EstadoCivil] Traida de los tipos de estados civiles Success',
  abmTraerEstadosCivilesError: '[EstadoCivil] Traida de los tipos de estados civiles Error',
  abmBuscarEstados: '[EstadoCivil]  Filtrar los tipos de estados civiles',

  consultaTraerAfiliadoPorCuil: '[Afiliacion]  traer  Afiliacion por Cuil',
  guardarAfiliadoNuevo: '[Afiliacion]  guardar  Afiliado Nuevo',

  traerTipoRelacion: '[Relacion]  traer tipos de relacion por id Categoria',

  notificacionTraerNotificacionStart: '[Notificacion] trae de Notificacion Start',
  notificacionTraerNotificacionSuccess: '[Notificacion] Traida de Notificacion Success',
  notificacionTraerNotificacionError: '[Notificacion] Traida de Notificacion Error',
  notificacionTraerNotificacionLimpiar: '[Notificacion] Limpia los Notificacion',
  notificacionEliminarNotificacion: '[Notificacion] Elimina Notificacion',
  notificacionAgregarNotificacion: '[Notificacion] Agregar Notificacion',
  notificacionModificarNotificacion: '[Notificacion] Modificar Notificacion',

  bandejaTraerCantidades: '[Bandeja] Trae las Cantidades Por Estado',
  bandejaTraerStart: '[Bandeja] Traida de Bandeja Start',
  bandejaTraerSuccess: '[Bandeja] Traida de Bandeja Success',
  bandejaTraerError: '[Bandeja] Traida de Bandeja Error',
  bandejaLimpiar: '[Bandeja] Limpia los Bandeja',

  changeStepper: '[Stepper]  cambia el estado del stepper',

  grupoFamiliarCambioTitularidadTraerStart:
    '[Grupo Familiar Cambio Titularidad] Traida Start',
  grupoFamiliarCambioTitularidadTraerOrigenSuccess:
    '[Grupo Familiar Cambio Titularidad] Traida Origen Success',
  grupoFamiliarCambioTitularidadTraerDocOrigenSuccess:
    '[Grupo Familiar Cambio Titularidad] Traida Documentacion Origen Success',
  grupoFamiliarCambioTitularidadEvaluarDocOrigenSuccess:
    '[Grupo Familiar Cambio Titularidad] Evaluar Documentacion Origen Success',
  grupoFamiliarCambioTitularidadTraerDestinoSuccess:
    '[Grupo Familiar Cambio Titularidad] Traida Destino Success',
  grupoFamiliarCambioTitularidadTraerDocDestinoSuccess:
    '[Grupo Familiar Cambio Titularidad] Traida Documentacion Destino Success',
  grupoFamiliarCambioTitularidadEvaluarDocDestinoSuccess:
    '[Grupo Familiar Cambio Titularidad] Evaluar Documentacion Destino Success',
  grupoFamiliarCambioTitularidadTraerError:
    '[Grupo Familiar Cambio Titularidad] Traida Error',
  grupoFamiliarCambioTitularidadOrigenLimpiar:
    '[Grupo Familiar Cambio Titularidad] Origen Limpiar',
  grupoFamiliarCambioTitularidadDestinoLimpiar:
    '[Grupo Familiar Cambio Titularidad] Destino Limpiar',

  indicadoresTraerStart: '[Indicadores] Traida Start',
  indicadoresUltimasTraerSuccess: '[Indicadores] Traida Ultimas Success',
  indicadoresCantidadesxAfiliacionTraerSuccess: '[Indicadores] Traida Cantidades X Afiliacion Success',
  indicadoresCantidadBajasAltasxSeccionalFechaTraerSuccess: '[Indicadores] Traida Cantidades Alta y Bajas de Afiliados X Fecha Success',
  indicadoresCantidadxFechaTraerSuccess: '[Indicadores] Traida Cantidad Afiliacion X Fecha Success',
  indicadoresCantidadxFechaBajasTraerSuccess: '[Indicadores] Traida Cantidad Afiliacion Bajas X Fecha Success',
  indicadoresTurnosEstadoTraerSuccess: '[Indicadores] Traida Estado Turnos Success',
  indicadoresTraerError: '[Indicadores] Traida Error',
  indicadoresLimpiar: '[Indicadores] Limpiar',
  indicadoresReporteCustomTraerSuccess: '[Indicadores] Traer Reportes Custom',
  indicadoresTraerInfoAfiliadosSeccionalSuccess: '[Indicadores] Traer Info Afiliados Seccional Success',
  indicadoresTraerInfoAfiliadosSeccionalError: '[Indicadores] Traer Info Afiliados Seccional Error',
  indicadoresTraerDetalleSolicitudesAutorizacionesSucces: '[Indicadores] Traer Info Detalle Autorizaciones Succes',
  indicadoresTraerDetalleSolicitudesAutorizacionesError: '[Indicadores] Traer Info Detalle Autorizaciones Error',
  setFiltrosReportesCustom: '[Indicadores] Traer Filtros',
  setColumnasSinMostrarReportesCustom: '[Indicadores] Seteamos las columnas que no se muestran en el reporte',
  setColumnasMostradasReportesCustom: '[Indicadores] Seteamos las columnas que se muestran en el reporte',


  movimientosTraerStart: '[Movimientos] Traida Start',
  movimientosTraerSuccess: '[Movimientos] Traida Ultimas Success',
  movimientosLimpiar: '[Movimientos] Limpiar Success',

  movimientosUserTraerStart: '[Movimientos User] Traida Start',
  movimientosUserTraerSuccess: '[Movimientos User] Traida Ultimas Success',
  movimientosFindSucces: '[Movimientos filtrados User] filtro busqueda',

  candidatosBajaTraerStart: '[Candidatos Baja] Traida de Candidatos Baja Start',
  candidatosBajaTraerSuccess: '[Candidatos Baja] Traida de Candidatos Baja Success',
  candidatosBajaTraerError: '[Candidatos Baja] Traida de Candidatos Baja Error',
  candidatosBajaLimpiar: '[Candidatos Baja] Limpia Candidatos Baja',
  candidatosBajaFiltrar: '[Filtrar Candidatos Baja] Filtrar Candidatos Baja',

  preAfiliacionesTomadasTraerStart:
    '[PreAfiliaciones Tomadas] Traida de PreAfiliaciones Tomadas Start',
  preAfiliacionesTomadasTraerSuccess:
    '[PreAfiliaciones Tomadas] Traida de PreAfiliaciones Tomadas Success',
  preAfiliacionesTomadasUsuarioTraerSuccess:
    '[PreAfiliaciones Tomadas] Traida de PreAfiliaciones Tomadas Por Usuario Success',
  preAfiliacionesTomadasTraerError:
    '[PreAfiliaciones Tomadas] Traida de PreAfiliaciones Tomadas Error',
  preAfiliacionesTomadasUsuarioAgregar:
    '[PreAfiliaciones Tomadas] Agregar PreAfiliaciones Tomadas',
  preAfiliacionesTomadasLiberar:
    '[PreAfiliaciones Tomadas] Liberar PreAfiliaciones Tomadas',
  preAfiliacionesTomadasUsuarioLiberar:
    '[PreAfiliaciones Tomadas] Liberar PreAfiliaciones Tomadas Usuario',
  preAfiliacionesTomadasLimpiar:
    '[PreAfiliaciones Tomadas] Limpia PreAfiliaciones Tomadas',

  reportesTraerStart: '[Reportes] Traida de Reportes Start',
  reportesTraerSuccess: '[Reportes] Traida de Reportes Success',
  reportesTraerError: '[Reportes] Traida de Reportes Error',
  reportesLimpiar: '[Reportes] Limpia Reportes',
  reportesBuscar: '[Reportes] Buscar Reporte',

  causaBajaTraerStart: '[Causa Baja] Traida de Causa Baja Start',
  causaBajaTraerSuccess: '[Causa Baja] Traida de Causa Baja Success',
  causaBajaTraerError: '[Causa Baja] Traida de Causa Baja Error',

  agendaTraerStart: '[Agenda] Traida de Agenda Start',
  agendaDiasTraerSuccess: '[Agenda] Traida de Dias Agenda Success',
  agendaHorariosTraerSuccess: '[Agenda] Traida de Horarios Agenda Success',
  agendaDiasSobreturnosTraerSuccess: '[Agenda] Traida de Dias Sobreturnos Agenda Success',
  agendaTurnosDisponiblesTraerSuccess: '[Agenda] Traida de Turnos Disponibles Agenda Success',
  agendaTurnosSeleccionarSuccess: '[Agenda] SeleccionarTurno Agenda Success',
  agendaTurnosLimpiar: '[Agenda] Traida de Turnos Agenda limpiar',
  agendaTurnosSuccess: '[Agenda] Traida de Turnos Agenda Success',
  agendaContadoresSuccess: '[Agenda] Traida de Contadores Afiliado Agenda Success',
  agendaCancelarTurnoSuccess: '[Agenda] Cancelar Turno Agenda Success',
  agendaExentarPagoTurnoSuccess: '[Agenda] Exentar Pago de Turno Success',
  agendaTurnoModificarAsistenciaSuccess: '[Agenda] Modificar Asistencia Turno Agenda Success',
  agendaTraerError: '[Agenda] Traida de Agenda Error',
  agendaLimpiarSeleccionado: '[Agenda] Limpia Seleccionado Agenda',
  agendaLimpiarDisponibles: '[Agenda] Limpia Disponibles Agenda',
  agendaLimpiarItems: '[Agenda] Limpia Items Agenda',
  agendaLimpiar: '[Agenda] Limpia Agenda',
  agendaGetPracticasSuccess: '[Agenda] Traida de Practicas Agenda Success',
  agendaGetPracticasError: '[Agenda] Traida de Practicas Agenda Error',
  agendaGetPacientesEnSalaSuccess: '[Agenda] Traida de pacientes en sala Agenda',
  agendaGetPacientesEnEsperaSuccess: '[Agenda] Traida de pacientes en espera Agenda',

  //AUTOPERCEPCION AFILIADO
  agendaAutopercepcionAfiliadoGetSuccess: '[AutopercepcionAfiliado] Traida de Autopercepcion Afiliado Success',
  agendaAutopercepcionAfiliadoGetError: '[AutopercepcionAfiliado] Traida de Autopercepcion Afiliado Error',

  //PISO Y CONSULTORIO TEST
  agendaSetPisoConsultorioTest: '[Agenda] Set Piso y ConsultorioS Success',

  //RELACION PRACTICAS MEDICOS TURNOS
  traerRelacionMedicoPractica: '[Turnos] Traida de Practicas Relacionadas al Medico',
  relacionMedicoPracticaError: '[Turnos] Error traida de Practicas Relacionadas al Medico',

  cambiosAgendaTraerStart: '[Cambios Agenda] Traida Start',
  cambiosAgendaTraerOrigenSuccess: '[Cambios Agenda] Traida Origen Success',
  cambiosAgendaTraerDestinoSuccess: '[Cambios Agenda] Traida Destino Success',
  cambiosAgendaTraerError: '[Cambios Agenda] Traida Error',
  cambiosAgendaOrigenLimpiar: '[Cambios Agenda] Origen Limpiar',
  cambiosAgendaDestinoLimpiar: '[Cambios Agenda] Destino Limpiar',

  motivosBajaTurnoTraerStart:
    '[Motivos Baja Turno] Traida de Motivos Baja Turno Start',
  motivosBajaTurnoTraerSuccess:
    '[Motivos Baja Turno] Traida de Motivos Baja Turno Success',
  motivosBajaTurnoTraerError:
    '[Motivos Baja Turno] Traida de Motivos Baja Turno Error',
  motivosBajaTurnoLimpiar: '[Motivos Baja Turno] Limpia Motivos Baja Turno',
  motivosBajaTurnoModificar: '[motivosBajaTurno] Modificar motivosBajaTurno',
  motivosBajaTurnoAgregar: '[motivosBajaTurno] Agregar motivosBajaTurno',
  motivosBajaTurnoEliminar: '[motivosBajaTurno] Eliminar motivosBajaTurno',
  motivosBajaTurnoBuscar: '[motivosBajaTurno] Buscar motivosBajaTurno',

  efectorHorariosTraerStart:
    '[Efector Horarios] Traida de Efector Horarios Start',
  efectorHorariosTraerSuccess:
    '[Efector Horarios] Traida de Efector Horarios Success',
  horariosMedicosTraerSuccess:
    '[Efector Horarios] Traida de horarios medicos Success',
  efectorHorariosDemandaTraerSuccess:
    '[Efector Horarios] Traida de Efector Horarios Demanda Success',
  efectorHorariosTraerError:
    '[Efector Horarios] Traida de Efector Horarios Error',
  horariosMedicosTraerError:
    '[Efector Horarios] Traida de Horarios medicos Error',
  efectorHorarioSeleccionar: '[Efector Horarios] Seleccionar Efector Horario',
  efectorHorariosLimpiar: '[Efector Horarios] Limpia Efector Horarios',
  efectorHorariosUpdateDisabled:
    '[Efector Horarios] Modificar disabled Efector Horario',
  efectorHorariosInHabilitarGenerar:
    '[Efector Horarios] InHabilitar Generar Efector Horario',
  efectorHorariosModificarInHabilitado:
    '[Efector Horarios] Modificar InHabilitado Efector Horario',
  especialidadesHorarioDemandaTraerSuccess:
    '[Efector Horarios] Traida de Especialidades Horarios Demanda Success',
  

  feriadosTraerStart: '[Feriados] Traida de Feriados Start',
  feriadosTraerSuccess: '[Feriados] Traida de Feriados Success',
  feriadosTraerError: '[Feriados] Traida de Feriados Error',
  feriadosSeleccionar: '[Feriados] Seleccionar Feriado',
  feriadosLimpiar: '[Feriados] Limpia Feriados',
  feriadosModificar: '[Feriados] Modificar Feriado',
  feriadosEliminar: '[Feriados] Eliminar Feriado',
  feriadosAgregar: '[Feriados] Agregar Feriado',
  feriadosSetCentrosFeriados: '[Feriados] Set Centros Feriados',

  licenciasProfesionalesTraerStart:
    '[Licencias Profesionales] Traida de Licencias Profesionales Start',
  licenciasProfesionalesTraerSuccess:
    '[Licencias Profesionales] Traida de Licencias Profesionales Success',
  licenciasProfesionalesTraerError:
    '[Licencias Profesionales] Traida de Licencias Profesionales Error',
  licenciasProfesionalesSeleccionar:
    '[Licencias Profesionales] Seleccionar Licencias Profesionales',
  licenciasProfesionalesUpdateDisabled:
    '[Licencias Profesionales] Modificar disabled Licencias Profesionales',
  licenciasProfesionalesLimpiar:
    '[Licencias Profesionales] Limpia Licencias Profesionales',
  licenciasProfesionalesModificarInHabilitado:
    '[Licencias Profesionales] Modificar InHabilitado Efector Horario',

  resolucionesTraerStart: '[Resoluciones] Traida de Resoluciones Start',
  resolucionesTraerSuccess: '[Resoluciones] Traida de Resoluciones Success',
  resolucionesTraerError: '[Resoluciones] Traida de Resoluciones Error',
  resolucionesSeleccionar: '[Resoluciones] Seleccionar Resolucion',
  resolucionesModificar: '[Resoluciones] Modificar Resolucion',
  resolucionesEliminar: '[Resoluciones] Eliminar Resolucion',
  resolucionesLimpiar: '[Resoluciones] Limpiar Resoluciones',

  cuotasTraerStart: '[Cuotas] Traida de Cuotas Start',
  cuotasTraerSuccess: '[Cuotas] Traida de Cuotas Success',
  cuotasTraerError: '[Cuotas] Traida de Cuotas Error',
  cuotasSeleccionar: '[Cuotas] Seleccionar Cuota',
  cuotasModificar: '[Cuotas] Modificar Cuota',
  cuotasEliminar: '[Cuotas] Eliminar Cuota',
  cuotasLimpiar: '[Cuotas] Limpiar Cuotas',

  facturasAfiliadoTraerStart:
    '[Facturas Afiliado] Traida de Facturas Afiliado Start',
  facturasAfiliadoTraerSuccess:
    '[Facturas Afiliado] Traida de Facturas Afiliado Success',
  facturasAfiliadoTraerError:
    '[Facturas Afiliado] Traida de Facturas Afiliado Error',
  facturasAfiliadoSeleccionado: '[Facturas Afiliado] Seleccionar Factura',
  facturasAfiliadoSeleccionadoLimpiar:
    '[Facturas Afiliado] Seleccionado Limpiar',
  facturasAfiliadoDetalleSeleccionadoTraerSuccess:
    '[Facturas Afiliado] Detalle Comp Seleccionado Success',
  facturasAfiliadoModificar: '[Facturas Afiliado] Modificar Factura Afiliado',
  facturasAfiliadoEliminar: '[Facturas Afiliado] Eliminar Factura Afiliado',
  facturasAfiliadoLimpiar: '[Facturas Afiliado] Limpiar Facturas Afiliado',
  facturasAfiliadoConsultaSuccess: '[Facturas Afiliado] Consulta Success',
  facturasAfiliadoConsultaError: '[Facturas Afiliado] Consulta Error',

  observacionFacturacionTraerStart:
    '[Observación Facturación] Traida de Observación Facturación Start',
  observacionFacturacionTraerSuccess:
    '[Observación Facturación] Traida de Observación Facturación Success',
  observacionFacturacionTraerError:
    '[Observación Facturación] Traida de Observación Facturación Error',
  observacionFacturacionLimpiar:
    '[Observación Facturación] Limpiar Observación Facturación',

  propuestaFacturacionTraerStart:
    '[Propuesta Facturacion] Traida de Propuesta Facturacion Start',
  propuestaFacturacionEliminar: '[Propuesta Facturacion] Eliminar',
  propuestaFacturacionTraerSuccess:
    '[Propuesta Facturacion] Traida de Propuesta Facturacion Success',
  propuestaFacturacionTraerError:
    '[Propuesta Facturacion] Traida de Propuesta Facturacion Error',
  propuestaFacturacionLimpiar:
    '[Propuesta Facturacion] Limpiar Propuesta Facturacion',
  propuestaFacturacionModificar:
    '[Propuesta Facturacion] Modificar Propuesta Facturacion',

  //MESA ENTRADA
  comprobanteMesaEntradaActualizacionEstado:
    '[Comprobante Mesa Entrada] Actualizar Estado Comprobante Mesa Entrada',
  comprobanteMesaEntradaClean:
    '[Comprobante Mesa Entrada] Comprobante Mesa Entrada Clean',
  comprobanteMesaEntradaEliminar:
    '[Comprobante Mesa Entrada] Eliminar Comprobante Mesa Entrada',
  comprobanteMesaDirectoEliminar:
    '[Comprobante Mesa Entrada] Eliminar Comprobante Mesa Entrada Directo',
  comprobanteMesaEntradaError:
    '[Comprobante Mesa Entrada] Traida de Comprobante Mesa Entrada Error',
  comprobanteMesaEntradaGuardar:
    '[Comprobante Mesa Entrada] Guardar Comprobante Mesa Entrada',
  comprobanteMesaEntradaModificar:
    '[Comprobante Mesa Entrada] Modificar Comprobante Mesa Entrada',
  comprobanteMesaEntradaStart:
    '[Comprobante Mesa Entrada] Traida de Comprobante Mesa Entrada Start',
  comprobanteMesaEntradaSuccess:
    '[Comprobante Mesa Entrada] Traida de Comprobante Mesa Entrada Success',
  comprobanteTomar: '[Comprobante Mesa Entrada] Tomar Comprobante Mesa Entrada',
  comprobanteLiberar:
    '[Comprobante Mesa Entrada] Liberar Comprobante Mesa Entrada',

  proformaMesaEntradaStart:
    '[Proforma Mesa Entrada] Traida de Proforma Mesa Entrada Start',
  proformaMesaEntradaSuccess:
    '[Proforma Mesa Entrada] Traida de Proforma Mesa Entrada Success',
  proformaMesaEntradaError:
    '[Proforma Mesa Entrada] Traida de Proforma Mesa Entrada Error',
  proformaMesaEntradaClean:
    '[Proforma Mesa Entrada] Proforma Mesa Entrada Clean',
  proformaMesaEntradaDelete:
    '[Proforma Mesa Entrada] Proforma Mesa Entrada Delete',
  tomarProforma: '[Proforma Tomada Mesa Entrada] Tomar Proforma',
  liberarProforma: '[Proforma Tomada Mesa Entrada] Liberar Proforma',
  setMenuProforma: '[Menu Proforma Mesa Entrada] Set Menu Proforma',
  setMenuComprobanteDocumentacion:
    '[Menu Comprobante Documentacion Mesa Entrada] Set Menu Comprobante Documentacion',
  getremitosSuccess: '[Remitos Mesa Entrada] get remitos mesa sucess',

  //RELACION TIPO TRAMITE
  relacionTramitesError:
    '[Relacion Tramite Area] Traida de Relacion Tramite Area Error',
  relacionTramiteAreaGuardar:
    '[Relacion Tramite Area] Guardar Relacion Tramite Area',
  relacionTramiteAreaEliminar:
    '[Relacion Tramite Area] Eliminar Relacion Tramite Area',
  relacionTramitesAreaSuccess:
    '[Relacion Tramite Area] Traida de Relacion Tramite Area Success',
  trackingRelacionTramiteAreaSuccess:
    '[Relacion Tramite Area] Traida de Tracking Relacion Tramite Area Success',
  trackingRelacionTramiteError:
    '[Relacion Tramite Area] Error Traida de Tracking Relacion Tramite Area Success',
  abmRelacionTramiteAreaBuscar:
    '[Relacion Tramite Area] Busqueda Relacion Tramite Area',
  //

  postTramitesType: '[Tramites ABM] Post Tramite ABM',
  putTramitesType: '[Tramites ABM] Put Tramite ABM',
  deleteTramitesType: '[Tramites ABM] Delete Tramite ABM',

  datosComprobanteStart:
    '[Datos Comprobante] Traida de Datos Comprobante Start',
  datosExpedienteStart: '[Datos Expediente] Traida de Datos Expediente Start',
  destinosSuccess: '[Destinos] Traida de Destinos Success',
  destinosError: '[Destinos] Traida de Destinos Error',

  abmTraerTramites: '[AbmDestinosComprobantes] Traida de Tramites',
  abmTraerDestinos: '[AbmDestinosComprobantes] Traida de Destinos',
  abmBuscarTramitesDestino:
    '[AbmDestinosComprobantes] Busqueda de Relaciones Tramites destinos',

  mesaEntradaCleanPresupuestos: '[Presupuestos Mesa Entrada] Presupuestos Mesa Entrada Clean',
  mesaEntradaGetPresupuestosSuccess: '[Presupuestos Mesa Entrada] Traida de Presupuestos Mesa Entrada Success',
  mesaEntradaTomarPresupuesto: '[Presupuesto Mesa Entrada] Tomar Presupuesto Mesa Entrada Success',
  mesaEntradaLiberarPresupuesto: '[Presupuesto Mesa Entrada] Liberar de Presupuesto Mesa Entrada Success',
  mesaEntradaDeletePresupuesto: '[Presupuesto Mesa Entrada] Delete de Presupuesto Mesa Entrada Success',

  mesaEntradaGetCotizacionesError: '[Cotizaciones Mesa Entrada] Traida de Cotizaciones Mesa Entrada Error',
  mesaEntradaGetCotizacionesSuccess: '[Cotizaciones Mesa Entrada] Traida de Cotizaciones Mesa Entrada Success',
  mesaEntradaTomarCotizacion: '[Cotizacion Mesa Entrada] Tomar Cotizaciones Mesa Entrada Success',
  mesaEntradaLiberarCotizacion: '[Cotizacion Mesa Entrada] Liberar Cotizaciones Mesa Entrada Success',

  mesaEntradaSetStep: '[Stepper Mesa Entrada] Set Stepper Mesa Entrada',

  solicMesaEntradaStart:
    '[Lineas Solicitudes Mesa Entrada] Traida de Lineas Solicitudes Mesa Entrada Start',
  solicMesaEntradaSuccess:
    '[Lineas Solicitudes Mesa Entrada] Traida de Lineas Solicitudes Mesa Entrada Success',
  solicMesaEntradaError:
    '[Lineas Solicitudes Mesa Entrada] Traida de Lineas Solicitudes Mesa Entrada Error',
  solicMesaEntradaClean:
    '[Lineas Solicitudes Mesa Entrada] Lineas Solicitudes Mesa Entrada Clean',

  procedenciaError: '[Procedencia] Traida de Procedencia Error',
  procedenciaSuccess: '[Procedencia] Traida de Procedencia Success',

  recepcionComprobanteSetMenu: '[Recepcion Comprobante Menu] Recepcion Comprobante Set Menu',
  setActiveBreadcrumbMesa: '[Active Breadcrumb] Set Active Breadcrumb Mesa Entrada',
  tipoEfectorMenuSet: '[Tipo Efector Menu Mesa] Set Tipo Efector Menu Mesa Entrada',

  tipoComprobanteError: '[Tipo Comprobante] Traida de Tipo Comprobante Error',
  tipoComprobanteSuccess: '[Tipo Comprobante] Traida de Tipo Comprobante Success',
  tramitesError: '[Tramites] Traida de Tramites Error',
  tramitesSuccess: '[Tramites] Traida de Tramites Success',
  tipoFacturaError: '[Tipo Factura] Traida de Tipo Factura Error',
  tipoFacturaSuccess: '[Tipo Factura] Traida de Tipo Factura Success',
  trackingExpedientesSuccess: '[Tracking Expedientes] GET Tracking Expedientes Success',
  trackingExpedientesError: '[Tracking Expedientes] GET Tracking Expedientes Error',

  // Documentacion Mesa
  documentacionMesaEntradaEliminar:
    '[Documentacion Mesa Entrada] Eliminar Documentacion Mesa Entrada',
  documentacionMesaEntradaError:
    '[Documentacion Mesa Entrada] Documentacion Mesa Entrada Error',
  documentacionMesaEntradaInsert:
    '[Documentacion Mesa Entrada] Insert Documentacion Mesa Entrada',
  documentacionMesaEntradaSucces:
    '[Documentacion Mesa Entrada] Documentacion Mesa Entrada Success',
  documentacionMesaEntradaClean:
    '[Documentacion Mesa Entrada] Documentacion Mesa Entrada Clean',

  usuarioLiquidacionesSuccess:
    '[Usuario Liquidaciones Mesa Entrada] Traida Usuario Liquidaciones Mesa Entrada Success',
  usuarioLiquidacionesError:
    '[Usuario Liquidaciones Mesa Entrada] Traida Usuario Liquidaciones Mesa Entrada Error',
  setUsuarioLiquidaciones:
    '[Usuario Liquidaciones Mesa Entrada] Set Usuario Liquidaciones Mesa Entrada',
  //MESA ENTRADA

  efectoresPTraerStart: '[EfectoresP] Traida de EfectoresP Start',
  efectoresPTraerSuccess: '[EfectoresP] Traida de EfectoresP Success',
  efectoresPTraerError: '[EfectorP] Traida de EfectoresP Error',
  efectoresPLimpiar: '[EfectorP] Limpiaes EfectoresP',
  efectoresPsetOrDeleteSobreturnos:
    '[EfectorP] Setear o Eliminar Configuracion Sobreturnos del EfectoresP',

  centrosMedicosPropiosTraerStart: '[centrosMedicosPropios] Traida de centrosMedicosPropios Start',
  centrosMedicosPropiosTraerSuccess: '[centrosMedicosPropios] Traida de centrosMedicosPropios Success',
  centrosMedicosPropiosTraerError: '[EfectorP] Tesraida de centrosMedicosPropios Error',
  centrosMedicosPropiosLimpiar: '[EfectorP] Limpiaes centrosMedicosPropios',

  archivosMigracionTraer: '[ARCHIVO MIGRACION] Traer Archivos Migracion',
  archivosMigracionSuccess: '[ARCHIVO MIGRACION] Success Archivos Migracion',
  novedadesSuccess: '[ARCHIVO MIGRACION] Traer Novedades Migracion',
  archivosMigracionError: '[ARCHIVO MIGRACION] Error Archivos Migracion',
  parametrosImportacionTraer: '[PARAMETROS IMPORTACION] Traer PARAMETROS IMPORTACION',
  parametrosImportacionSuccess: '[PARAMETROS IMPORTACION] Success PARAMETROS IMPORTACION',
  parametrosImportacionError: '[PARAMETROS IMPORTACION] Error PARAMETROS IMPORTACION',

  archivosContratacionesTraer:
    '[ARCHIVO CONTRATACIONES] Traer Archivos Contrataciones',
  archivosContratacionesSuccess:
    '[ARCHIVO CONTRATACIONES] Success Archivos Contrataciones',
  novedadesContratacionesSuccess:
    '[ARCHIVO CONTRATACIONES] Traer Novedades Contrataciones',
  archivosContratacionesError:
    '[ARCHIVO CONTRATACIONES] Error Archivos Contrataciones',
  parametrosContratacionesTraer:
    '[PARAMETROS CONTRATACIONES] Traer PARAMETROS Contrataciones',
  parametrosContratacionesSuccess:
    '[PARAMETROS CONTRATACIONES] Success PARAMETROS Contrataciones',
  parametrosContratacionesError:
    '[PARAMETROS CONTRATACIONES] Error PARAMETROS Contrataciones',
  // AFILIADO
  traerCredencialesStart: '[Afiliado-Credenciales] Traer credenciales start',
  traerCredencialesSuccess:
    '[Afiliado-Credenciales] Traer credenciales success',
  traerCredencialesError: '[Afiliado-Credenciales] Traer credenciales error',
  changeStepperTurnoAfiliado: '[Afiliado-Turno] Cambiar paso de stepper',

  traerTurnosDiasStart: '[Afiliado-Turnos] Traer Turnos Dias start',
  traerTurnosDiasError: '[Afiliado-Turnos] Traer Turnos Dias error',
  traerTurnosDiasSuccess: '[Afiliado-Turnos] Traer Turnos Dias success',
  traerTurnosHorasStart: '[Afiliado-Turnos] Traer Turnos Horas start',
  traerTurnosHorasError: '[Afiliado-Turnos] Traer Turnos Horas error',
  traerTurnosHorasSuccess: '[Afiliado-Turnos] Traer Turnos Horas success',
  traerTurnosHorariosStart: '[Afiliado-Turnos] Traer Turnos Horarios start',
  traerTurnosHorariosError: '[Afiliado-Turnos] Traer Turnos Horarios error',
  traerTurnosHorariosSuccess: '[Afiliado-Turnos] Traer Turnos Horarios success',
  traerPrimerTurnoDisponibleStart:
    '[Afiliado-Turnos] Traer primer turno disponible start',
  traerPrimerTurnoDisponibleError:
    '[Afiliado-Turnos] Traer primer turno disponible error',
  seleccionarTurnoAfiliado: '[Afiliado-Turnos] Seleccionar Turno Afiliado',
  traerTurnosAfiliadoStart: '[Afiliado-Turnos] Traer Turnos Afiliado start',
  traerTurnosAfiliadoError: '[Afiliado-Turnos] Traer Turnos Afiliado error',
  traerTurnosAfiliadoSuccess: '[Afiliado-Turnos] Traer Turnos Afiliado success',
  traerHistorialTurnosAfiliadoStart:
    '[Afiliado-Turnos] Traer HISTORIAL Turnos Afiliado start',
  traerHistorialTurnosAfiliadoError:
    '[Afiliado-Turnos] Traer HISTORIAL Turnos Afiliado error',
  traerHistorialTurnosAfiliadoSuccess:
    '[Afiliado-Turnos] Traer HISTORIAL Turnos Afiliado success',
  traerMotivosBajaTurnosStart:
    '[Afiliado-Turnos] Traer MotivosBajaTurnos start',
  traerMotivosBajaTurnosError:
    '[Afiliado-Turnos] Traer MotivosBajaTurnos error',
  traerMotivosBajaTurnosSuccess:
    '[Afiliado-Turnos] Traer MotivosBajaTurnos success',
  limpiarDatosDeTurnosParametrosAnteriores:
    '[Afiliado-Turnos] Limpiar hoas, dias y turnos disponibles',

  observacionesSeguimientoTraerStart:
    '[Observaciones Seguimiento] Traida de Observaciones Seguimiento Start',
  observacionesSeguimientoTraerSuccess:
    '[Observaciones Seguimiento] Traida de Observaciones Seguimiento Success',
  observacionesSeguimientoTraerError:
    '[Observaciones Seguimiento] Traida de Observaciones Seguimiento Error',
  observacionesSeguimientoLimpiar:
    '[Observaciones Seguimiento] Limpia las Observaciones Seguimiento',
  observacionesSeguimientoInsertSuccess:
    '[Observaciones Seguimiento] Insert Success Observaciones Seguimiento',
  observacionesSeguimientoInsertStart:
    '[Observaciones Seguimiento] Insert Start Observaciones Seguimiento',
  observacionesSeguimientoUpdateSuccess:
    '[Observaciones Seguimiento] Update Success Observaciones Seguimiento',
  observacionesSeguimientoUpdateStart:
    '[Observaciones Seguimiento] Update Start Observaciones Seguimiento',

  //LIQUIDACIONES EFECTOR
  efectoresPorLiquidadorTraerStart:
    '[Efectores Por Liquidador] Traida de Efectores Por Liquidador Start',
  efectoresPorLiquidadorTraerSuccess:
    '[Efectores Por Liquidador] Traida de Efectores Por Liquidador Success',
  efectoresPorLiquidadorTraerError:
    '[Efectores Por Liquidador] Traida de Efectores Por Liquidador Error',
  efectoresPorLiquidadorInsert:
    '[Efectores Por Liquidador] Insert Efectores Por Liquidador',
  efectoresPorLiquidadorDelete:
    '[Efectores Por Liquidador] Delete Efectores Por Liquidador',
  efectoresPorLiquidadorPorUsuarioTraerSuccess:
    '[Efectores Por Liquidador] Traida de Efectores Por Liquidador Por Usuario Success',
  efectoresPorLiquidadorPorUsuarioTraerError:
    '[Efectores Por Liquidador] Traida de Efectores Por Liquidador Por Usuario Error',

  recetasDigitalesGetTiposRecetasSuccess: '[recetas] Get Tipos Recetas Success',
  recetasDigitalesGetTiposRecetasError: '[recetas] Get Tipos Recetas Error',
  recetasDigitalesGetSubtiposRecetasSuccess: '[recetas] Get Subtipos Recetas Success',
  recetasDigitalesGetSubtiposRecetasError: '[recetas] Get Subtipos Recetas Error',
  recetasDigitalesSetRecetaSeleccionada: '[recetas] Set Receta Seleccionada',
  recetasDigitalesUpdateRecetaSeleccionada: '[recetas] Update Receta Seleccionada',

  recetasDigitalesGetBuscadorMedicamentosSuccess: '[recetas] GET Buscador Medicamentos Success',
  recetasDigitalesGetBuscadorMedicamentosError: '[recetas] GET Buscador Medicamentos Error',
  recetasDigitalesResetBuscadorMedicamentos: '[recetas] Reset Buscador Medicamentos',
  recetasDigitalesAddMedicamento: '[recetas] Add Medicamento',
  recetasDigitalesUpdateEstadoRecetas: '[recetas] Update Estado Recetas',
  recetasDigitalesGetRecetasSuccess: '[recetas] Get Recetas Success',
  recetasDigitalesCleanRecetas: '[recetas] Clean Recetas',
  recetasDigitalesGetRecetasError: '[recetas] Get Solicitudes Error',
  recetasDigitalesGetContadoresRecetasSuccess: '[recetas] Get Contadores Recetas Success',
  recetasDigitalesGetContadoresRecetasError: '[recetas] Get Contadores Recetas Error',
  recetasDigitalesSetShowForm: '[recetas] Set Show Form',
  recetasDigitalesSetAfiliadoSeleccionado: '[recetas] Set Afiliado Seleccionado',
  recetasDigitalesUpdateAfiliadoSeleccionado: '[recetas] Update Afiliado Seleccionado',
  recetasDigitalesClearReducer: '[recetas] Clear Reducer',
  recetasDigitalesSetRecetaSeleccionadaMedicamentos: '[recetas] Set Medicamentos Seleccionada',
  recetasDigitalesAnularRecetasSuccess: '[recetas] Anular Receta de historial',
  recetasDigitalesSetStep: '[recetas] Set Step',
  recetasDigitalesCleanAfiliadoSeleccionado: '[recetas] Clean Afiliado Seleccionado',
  traerProvinciasCSFSuccess: '[recetas] Traer provinciasCSF Success',
  traerProvinciasCSFError: '[recetas] Traer provinciasCSF Error',


  recetasDigitalesGetMedicamentosSuccess: '[recetas] Get Medicamentos Success',
  recetasDigitalesSetMedicamentos: '[receta] Set Medicamentos',

  //LIQUIDACIONES
  liquidacionesClearReducer: '[liquidaciones] Clear Reducer',
  liquidacionesUpdateEstadoComprobantes: '[liquidaciones] Update Estado Comprobantes',
  liquidacionesSetEfectorSeleccionado: '[liquidaciones] Set Efector Seleccionado',
  liquidacionesCleanEfectorSeleccionado: '[liquidaciones] Clean Efector Seleccionado',
  liquidacionesSetAfiliadoSeleccionado: '[liquidaciones] Set Afiliado Seleccionado',
  liquidacionesCleanAfiliadoSeleccionado: '[liquidaciones] Clean Afiliado Seleccionado',
  liquidacionesGetComprobantesSuccess: '[liquidaciones] Get Comprobantes Success',
  liquidacionesCleanComprobantes: '[liquidaciones] Clean Comprobantes',
  liquidacionesGetComprobantesError: '[liquidaciones] Get Comprobantes Error',
  liquidacionesComprobanteMarcarTomado: '[liquidaciones] Comprobante Marcar Tomado',
  liquidacionesGetContadoresComprobantesSuccess: '[liquidaciones] Get Contadores Comprobantes Success',
  liquidacionesGetContadoresComprobantesError: '[liquidaciones] Get Contadores Comprobantes Error',
  liquidacionesGetComprobantesContadoresError: '[liquidaciones] Get Comprobantes Contadores Error',
  //COMPROBANTE SELECCIONADO
  liquidacionesSetComprobanteSeleccionado: '[liquidaciones] Set Comprobantes Seleccionado',
  liquidacionesCleanComprobanteSeleccionado: '[liquidaciones] Clean Comprobantes Seleccionado',
  liquidacionesUpdateComprobanteSeleccionado: '[liquidaciones] Update Comprobantes Seleccionado',
  liquidacionesUpdateEstadoComprobanteSeleccionado: '[liquidaciones] Update Estado Comprobante Seleccionado',
  liquidacionesUpdateEmailEfectorComprobanteSeleccionado: '[liquidaciones] Update Email Efector Comprobante Seleccionado',
  //TOTAL LINEAS COMPROBANTE
  liquidacionesUpdateTotalDebitosLineasComprobanteSeleccionado: '[liquidaciones] Update Total Debitos Lineas Comprobante Seleccionado',
  liquidacionesUpdateTotalLineasComprobanteSeleccionado: '[liquidaciones] Update Total Lineas Comprobante Seleccionado',
  //LINEAS PRESTACION
  liquidacionesGetLineasPrestacionComprobanteSuccess: '[lineas Prestacion] Get Lineas Prestacion Success',
  liquidacionesAddLineaPrestacionComprobante: '[linea Prestacion] Add Linea Prestacion',
  liquidacionesUpdateLineaNuevaPrestacionComprobante: '[linea Prestacion] Update Linea Nueva Prestacion',
  liquidacionesDeleteLineaPrestacionComprobante: '[linea Prestacion] Delete Linea Prestacion',
  liquidacionesUpdateLineaPrestacionComprobante: '[linea Prestacion] Update Linea Prestacion',
  liquidacionesCleanLineasPrestacionComprobante: '[lineas Prestacion] Clean Lineas',
  liquidacionesGetLineasPrestacionError: '[lineas Prestacion] Get Lineas Prestacion Error',
  //LINEAS INSUMOS
  liquidacionesGetLineasInsumosComprobanteSuccess: '[lineas Insumos] Get Lineas Prestacion Success',
  liquidacionesAddLineaInsumoComprobante: '[linea Insumo] Add Linea Insumo',
  liquidacionesUpdateLineaNuevaInsumoComprobante: '[linea Insumo] Update Linea Nueva Insumo',
  liquidacionesDeleteLineaInsumoComprobante: '[linea Insumo] Delete Linea Insumo',
  liquidacionesUpdateLineaInsumoComprobante: '[linea Insumo] Update Linea Insumo',
  liquidacionesCleanLineasInsumosComprobante: '[lineas Insumos] Clean Lineas',
  liquidacionesGetLineasInsumosError: '[lineas Insumos] Get Lineas Insumos Error',
  //LINEAS MEDICAMENTOS
  liquidacionesGetLineasMedicamentosComprobanteSuccess: '[lineas Medicamentos] Get Lineas Prestacion Success',
  liquidacionesCleanLineasMedicamentosComprobante: '[lineas Medicamentos] Clean Lineas',
  liquidacionesGetLineasMedicamentosError: '[lineas Medicamentos] Get Lineas Medicamentos Error',
  liquidacionesUpdateLineaNuevaMedicamentoComprobante: '[lineas Medicamentos] Update Linea Medicamento Comprobante Success',
  liquidacionesAddLineaMedicamentoComprobante: '[lineas Medicamentos]  Insert Linea Medicamento Comprobante Success',
  liquidacionesUpdateLineaMedicamentoComprobante: '[lineas Medicamentos]  Update linea de medicamento Success',
  liquidacionesDeleteLineaMedicamentoComprobante: '[lineas Medicamentos] Delete linea medicamento success',

  //COMPROBANTES TOMADOS
  liquidacionesComprobantesTomadosUsuarioSuccess: '[liquidaciones Tomadas] Traida de liquidaciones Tomadas Por Usuario Success',
  liquidacionesComprobantesTomadosUsuarioLiberar: '[liquidaciones Tomadas] Liberar liquidaciones Tomadas Usuario',
  comprobantesTomadosLiberarTomadoPorIdComprobante: '[liquidaciones Tomadas] Liberar liquidaciones Tomadas Usuario por id Comprobante',
  liquidacionesComprobantesTomadosUsuarioAgregar: '[liquidaciones Tomadas] Agregar liquidaciones Tomadas',
  liquidacionesComprobantesTomadosUsuarioError: '[liquidaciones Tomadas] liquidaciones Tomadas Por Usuario Usuario Error',
  liquidacionesComprobantesTomadosSuccess: '[liquidaciones Tomadas] Traida de liquidaciones Tomadas Success',
  liquidacionesComprobantesTomadosLiberar: '[liquidaciones Tomadas] Liberar liquidaciones Tomadas',
  liquidacionesComprobantesTomadosError: '[liquidaciones Tomadas] Liquidaciones Tomadas Error',
  liquidacionesComprobantesTomadosLimpiar: '[liquidaciones Tomadas] Limpiar liquidaciones Tomadas',
  liquidacionesUpdateComprobanteContrato: '[liquidaciones Tomadas] Actualizar comprobante contrato liquidaciones Tomadas',
  //TRACKING LINEA COMPROBANTE
  trackingLineaComprobanteSuccess: '[liquidaciones Tracking Linea] Traida de Tracking Linea Success',
  trackingLineaComprobanteError: '[liquidaciones Tracking Linea] Traida de Tracking Linea Error',

  //MOTIVOS DEBITO
  liquidacionesGetMotivosDebitoSuccess: '[liquidaciones motivos debitos] Traida de motivos debitos Success',

  //DOCUMENTACION LIQUI
  getTiposDocumentacionLiqui: '[liquidaciones] Get tipos documentacion Success',
  getDocumentacionXIdExpedienteLiqui: '[liquidaciones] Get documentacion por id expediente Success',


  //COMPRAS 
  estadosCotizacionesTraerStart: '[Compras] Traer estados de cotizaciones',
  estadosCotizacionesTraerSuccess: '[Compras] Traer estados de cotizaciones success',
  estadosCotizacionesTraerError: '[Compras] Traer estados de cotizaciones error',
  updateEstadosSolicitudesCotizacion: '[Compras] set estados de solicitudes cotizacion',
  solicitudesCotizacionTraerStart: '[Compras] Traer solicitudes de cotizacion',
  solicitudesCotizacionSuccess: '[Compras] Traer solicitudes de cotizacion success',
  solicitudesCotizacionError: '[Compras] Traer solicitudes de cotizacion error',
  seleccionarOferente: '[Compras] Seleccionar oferente para cotizacion',
  desSeleccionarOferente: '[Compras] Limpiar seleccion de oferente',
  seleccionarIdSolicitud: '[Compras] Seleccionar id solicitud',
  seleccionarFechaInicio: '[Compras] Seleccionar fechaInicio',
  seleccionarFechaFin: '[Compras] Seleccionar fechaFin',
  seleccionarIdSolicitudAuditoria: '[Compras] Seleccionar id solicitud para auditoria facturas',
  seleccionarFechaInicioAuditoria: '[Compras] Seleccionar fechaInicio para auditoria facturas',
  seleccionarFechaFinAuditoria: '[Compras] Seleccionar fechaFin para auditoria facturas',
  getOferentesPorCotizacionSuccess: '[Compras] Traer oferentes por Cotizacion success',


  oferentesAbm: '[Compras] Traer oferentes',
  oferentesAbmSuccess: '[Compras] Traer oferentes success',
  oferentesAbmError: '[Compras] Traer oferentes failure',
  oferentesBuscarAbm: '[Compras] Buscar oferente',
  mailsOferentesSuccess: '[Compras] Traer mails oferentes',
  mailsOferentesClean: '[Compras] Limpiar mails',
  

  //Proveedores
  proveedorAgregar: '[Compras] Agregar Proveedor',
  proveedorAgregarSuccess: '[Compras] Agregar Proveedor Success',
  proveedorAgregarError: '[Compras] Agregar Proveedor Error',
  rubrosProveedores: '[Compras] traer rubros proveedores',
  rubrosProveedoresSuccess: '[Compras] Traer rubros proveedores success',
  rubrosProveedoresError: '[Compras] Traer rubros proveedores error',
  tipoProveedor: '[Compras] Traer tipos de proveedores',
  tipoProveedorSuccess: '[Compras] Traer tipos de proveedores success',
  tipoProveedorError: '[Compras] Traer tipos de proveedores error',
  desSeleccionarProveedorInfo: '[Compras] Limpiar Proveedor info',
  desSeleccionarProveedorDatosContacto:
    '[Compras] Limpiar Proveedor datos contacto',
  desSeleccionarProveedorDatosContable: '[Compras] Limpiar Proveedor contable',
  desSeleccionarProveedorDocumentacion:
    '[Compras] Limpiar Proveedor documentación',

  //Información Proveedor
  proveedorGuardarInformacion: '[Compras] Guardar información del proveedor',
  proveedorGuardarDatosContables:
    '[Compras] Guardar informacion contable del proveedor',

  //DatosContables
  datosContablesTraer: '[Compras] Traer datos contables de proveedor',
  datosContablesSuccess: '[Compras] Traer datos contables de proveedor success',
  datosContablesError: '[Compras] Traer datos contables de proveedor error',
  datosContactosTraer: '[Compras] Traer datos contactos de proveedor',
  datosContactosTraerSuccess: '[Compras] Traer datos contactos de proveedor success',
  datosContactosTraerError: '[Compras] Traer datos contactos de proveedor error',

  //DatosContacto
  traerDatosContables: '[Compras] Traer datos contables proveedor',
  traerDatosContablesSuccess: '[Compras] Traer datos contables proveedor success',
  traerDatosContablesError: '[Compras] Traer datos contables proveedor error',
  guardarDatosContacto: "[Compras] Guardar modificación datos contacto",
  guardarDatosContactoSuccess: "[Compras] Guardar modificación datos contacto success",
  guardarDatosContactoError: "[Compras] Guardar modificación datos contacto error",

  //DocumentacionProveedor
  traerDocumentacionProveedor: '[Compras] Traer documentacion proveedor',
  traerDocumentacionProveedorSuccess:
    '[Compras] Traer documentacion proveedor success',
  traerDocumentacionProveedorError:
    '[Compras] Traer documentacion proveedor error',

  comprasProveedorLimpiarSeleccion: '[Compras] Limpiar Seleccion proveedor',
  comprasProveedorConsultaLimpiarSeleccion:
    '[Compras] Limpiar Seleccion de proveedor consulta',
  comprasProveddorNuevoLimpiarSeleccion:
    '[Compras] Limpiar seleccion de proveedor nuevo',
  seleccionarAbmProveedor: '[Compras] Seleccionar proveedor para consulta',
  seleccionarAbmProveedorError:
    '[Compras] Seleccionar proveedor para consulta error',

  nuevaCotizacionSuccess: '[Compras] Nueva cotizacion exitosa',
  nuevaCotizacionError: '[Compras] Nueva cotizacion error',
  cotizacionesSucces: '[Compras] traer cotizaciones success',
  cotizacionesError: '[Compras] traer cotizaciones error',
  datoNuevoDetalleCotizacion: '[Compras] setear dato nuevo detalle cotizacion',
  getDocumentacionXIdCabeceraCotizacion: '[Compras] Traer documentacion por id',
  getTiposDocumentacion: '[Compras] Traer Tipos de Documentacion',
  setMaterialCompras: '[Compras] Setear Material',
  desSeleccionarMaterialCompras: '[Compras] desSeleccionar material',
  trackingSolicitudesCotizacionSuccess: '[Compras] Traer tracking solicitud cotizacion success',
  trackingSolicitudesCotizacionError: '[Compras] Traer tracking solicitud cotizacion error',
  contadoresEstadosCotizacionesSuccess: '[Compras] Traer contadores estados cotizaciones success',
  contadoresEstadosCotizacionesError: '[Compras] Traer contadores estados cotizaciones error',

  //COMPRAS AUDITORIA FACTURACION
  traerComprobantesAuditoriaFacturacionSuccess: '[Compras-AuditoriaFacturacion] Traer comprobantes exitoso',
  traerComprobantesAuditoriaFacturacionErrror: '[Compras-AuditoriaFacturacion] Traer comprobantes error',
  traerEstadosAuditoriaFacturacionSuccess: '[Compras-AuditoriaFacturacion] Trer Estados success',
  traerEstadosAuditoriaFacturacionError: '[Compras-AuditoriaFacturacion] Trer Estados error',
  contadoresEstadosAuditoriaSuccess: '[Compras-AuditoriaFacturacion] Traer contadores estados success',
  contadoresEstadosAuditoriaError: '[Compras-AuditoriaFacturacion] Traer contadores estadoserror',
  updateEstadosFacturacion: '[Compras-AuditoriaFacturacion] setear estado',
  seleccionarDetalleFacturacionSinCotizacion: '[Compras-AuditoriaFacturacion] Guardar detalle facturacion sin cotizacion',
  desSeleccionarDetalleFacturacion: '[Compras-AuditoriaFacturacion] desSeleccionar detalle',
  traerComprobantesPorEstadoSuccess: '[Compras-AuditoriaFacturacion] Traer Comprobantes Por Estado exitoso',
  traerComprobantesPorEstadoError: '[Compras-AuditoriaFacturacion] Traer Comprobantes Por Estado error',
  traerMaterialesTramiteSuccess: '[Compras-AuditoriaFacturacion] Traer materiales del tramite exitoso',
  traerMaterialesTramiteError: '[Compras-AuditoriaFacturacion] Traer materiales del tramite error',
  traerMaterialesCotizacionSuccess: '[Compras-AuditoriaFacturacion] Traer materiales de cotizacion success',
  traerMaterialesCotizacionError: '[Compras-AuditoriaFacturacion] Traer materiales de cotizacion error',
  traerMaterialesCotizacionLimpiar: '[Compras-AuditoriaFacturacion] Traer materiales de cotizacion limpiar',
  trackingFacturacionComprasSuccess: '[Compras] Traer tracking Facturacion success',
  trackingFacturacionComprasError: '[Compras] Traer tracking Facturacion error',


  startCobraCoseguro: '[Cobra Coseguro] Traer Cobra Coseguro start',
  errorCobraCoseguro: '[Cobra Coseguro] Traer Cobra Coseguro error',
  successCobraCoseguro: '[Cobra Coseguro] Traer Cobra Coseguro success',

  // DISCAPACIDAD
  setDiscapacidadRoute: '[Discapacidad] Modificacion ruta de Discapacidad',
  setBreadcrumbCud: '[Discapacidad] Modificacion breadcrumb solicitudes de Discapacidad',
  setDiscapacidadStep: '[Discapacidad] Set Step de Discapacidad',
  discapacidadClearReducer: '[discapacidad] Clean Reducer',
  discapacidadSetAfiliadoSeleccionado: '[discapacidad] Set Afiliado Seleccionado',
  discapacidadCleanAfiliadoSeleccionado: '[discapacidad] Clean Afiliado Seleccionado',
  discapacidadSetEfectorSeleccionado: '[discapacidad] Set Efector Seleccionado',
  discapacidadCleanEfectorSeleccionado: '[discapacidad] Clean Efector Seleccionado',
  discapacidadGetTiposPrestacionesSuccess: '[discapacidad] Traer Tipos de Prestaciones Success',
  discapacidadGetTiposPrestacionesError: '[discapacidad] Traer Tipos de Prestaciones Error',
  discapacidadGetTiposSolicitudesSuccess: '[discapacidad] Traer Tipos de Solicitudes Success',
  discapacidadGetTiposSolicitudesError: '[discapacidad] Traer Tipos de Solicitudes Error',
  discapacidadGetTiposTransportesSuccess: '[discapacidad] Traer Tipos de Transportes Success',
  discapacidadGetTiposTransportesError: '[discapacidad] Traer Tipos de Transportes Error',
  discapacidadGetSubTiposSolicitudesSuccess: '[discapacidad] Traer SubTipos de Solicitudes Success',
  discapacidadGetSubTiposSolicitudesError: '[discapacidad] Traer SubTipos de Solicitudes Error',
  discapacidadSetSolicitudSeleccionada: '[discapacidad] Set Solicitudes Seleccionada',
  discapacidadUpdateSolicitudSeleccionada: '[discapacidad] Update Solicitudes Seleccionada',
  discapacidadUpdateTerapiaSolicitudSeleccionada: '[discapacidad] Update Terapia Solicitudes Seleccionada',
  discapacidadUpdateTransporteSolicitudSeleccionada: '[discapacidad] Update Transporte Solicitudes Seleccionada',
  discapacidadGetTrackingSolicitudIntegracionSuccess: '[discapacidad] Get Tracking Solicitud Integracion Success',
  discapacidadGetTrackingSolicitudIntegracionError: '[discapacidad] Get Tracking Solicitud Integracion Error',
  discapacidadAddPractica: '[discapacidad] Add Practica',
  discapacidadSetPracticas: '[discapacidad] Set Practicas',
  discapacidadGetSolicitudesSuccess: '[discapacidad] Get Solicitudes Success',
  discapacidadGetContadoresSolicitudesSuccess: '[discapacidad] Get Contadores Solicitudes Success',
  discapacidadGetContadoresSolicitudesError: '[discapacidad] Get Contadores Solicitudes Error',
  discapacidadCleanSolicitudSeleccionada: '[discapacidad] CleanSolicitudSeleccionada',
  discapacidadCleanSolicitudes: '[discapacidad] Clean Solicitudes',
  discapacidadGetSolicitudesError: '[discapacidad] Get Solicitudes Error',
  discapacidadSetEstadoSolicitudes: '[discapacidad] Set Estado Solicitudes',
  discapacidadGetTiposDocumentacionSuccessAbm: '[discapacidad] Get Tipo Documentacion Abm Success',
  discapacidadGetTiposDocumentacionErrorAbm: '[discapacidad] Get Tipo Documentacion Abm Error',
  discapacidadCleanTiposDocumentacionAbm: '[discapacidad] Clean Tipo Documentacion Abm',
  discapacidadPostTiposDocumentacionAbm: '[discapacidad] Post Tipo Documentacion Abm',
  discapacidadPutTiposDocumentacionAbm: '[discapacidad] Put Tipo Documentacion Abm',
  discapacidadDeleteTiposDocumentacionAbm: '[discapacidad] Delete Tipo Documentacion Abm',
  discapacidadGetTiposDocumentacionSuccess: '[discapacidad] Get Tipo Documentacion Success',
  discapacidadGetTiposDocumentacionError: '[discapacidad] Get Tipo Documentacion Error',
  discapacidadPostTiposDocumentacion: '[discapacidad] Post Tipo Documentacion ',
  discapacidadPutTiposDocumentacion: '[discapacidad] Put Tipo Documentacion ',
  discapacidadDeleteTiposDocumentacion: '[discapacidad] Delete Tipo Documentacion ',
  discapacidadGetDocumentacionSuccess: '[discapacidad] Get Documentacion Success',

  discapacidadGetDocumentacionError: '[discapacidad] Get Documentacion Error',
  discapacidadSetFormularioCudSuccess: '[discapacidad] Set Formulario Cud Success',
  discapacidadGetDocumentacionAfiliadoSuccess: '[discapacidad] Get Documentacion Afiliado Success',
  discapacidadGetDocumentacionAfiliadoError: '[discapacidad] Get Documentacion Afiliado Error',

  discapacidadSolicitudesTomadasSuccess:
    '[solicitudes discapacidad Tomadas] Traida de solicitudes discapacidad Tomadas Success',
  discapacidadSolicitudesTomadasError:
    '[solicitudes discapacidad Tomadas] solicitudes discapacidad Tomadas Error',
  discapacidadSolicitudesTomadasUsuarioSuccess:
    '[solicitudes discapacidad Tomadas] Traida de solicitudes discapacidad Tomadas Por Usuario Success',
  discapacidadSolicitudesTomadasUsuarioError:
    '[solicitudes discapacidad Tomadas] solicitudes discapacidad Tomadas Por Usuario Usuario Error',
  discapacidadSolicitudesTomadasUsuarioAgregar:
    '[solicitudes discapacidad Tomadas] Agregar solicitudes discapacidad Tomadas',
  discapacidadSolicitudesTomadasLiberar:
    '[solicitudes discapacidad Tomadas] Liberar solicitudes discapacidad Tomadas',
  discapacidadSolicitudesTomadasUsuarioLiberar:
    '[solicitudes discapacidad Tomadas] Liberar solicitudes discapacidad Tomadas Usuario',
  discapacidadSolicitudesTomadasLimpiar:
    '[solicitudes discapacidad Tomadas] Limpia solicitudes discapacidad Tomadas',
  discapacidadSolicitudesMarcarTomada:
    '[solicitudes discapacidad Tomadas] solicitudes discapacidad marcar Tomadas',
  discapacidadSolicitudesDesmarcarLiberada:
    '[solicitudes discapacidad Tomadas] solicitudes discapacidad desmarcar Tomada',

  changeStepperDiscapacidadAfiliado: "[discapacidad auto gestión] Cambiar paso de stepper disca-autogestion",
  discapacidadSetSolicitudAutoGSeleccionada: '[discapacidad auto gestión] Update Set Solicitud Auto Gestión Seleccionada',
  discapacidadClearReducerAutoG: '[discapacidad auto gestión] Clean Reducer',
  discapacidadGetSolicitudesAutoGSuccess: '[discapacidad auto gestión] Get Solicitudes Success',
  discapacidadGetSolicitudesAutoGError: '[discapacidad auto gestión] Get Solicitudes Error',
  discapacidadSolicitudesAutoGStartLoading: '[discapacidad auto gestión] Start Loading Error',
  discapacidadSolicitudesAutoGFinishLoading: '[discapacidad auto gestión] Finish Loading Error',
  discapacidadUpdateTransporteSolicitudAutoGSeleccionada: '[discapacidad auto gestión] Update Transporte Solicitudes Seleccionada',
  discapacidadUpdateTerapiaSolicitudAutoGSeleccionada: '[discapacidad auto gestión] Update Terapia Solicitudes Seleccionada',

  discapacidadValorizacionesTraerStart: '[Nomenclador Discapacidad]  Inicio valorizaciones',
  discapacidadValorizacionesTraerSuccess: '[Nomenclador Discapacidad]  Traida de valorizaciones Success',
  discapacidadValorizacionesTraerError: '[Nomenclador Discapacidad]  Traida de valorizaciones Error',
  discapacidadValorizacionesSetActivosPorFecha: '[Nomenclador Discapacidad] SET Activos Por Fecha',
  discapacidadValorizacionesEditar: '[Nomenclador Discapacidad]  Editar valorizacion',

  cudSuccess: '[Discapacidad] Success certificados de Discapacidad',
  cudError: '[Discapacidad] Error certificados de Discapacidad',
  cudPost: '[Discapacidad] Post certificados de Discapacidad',
  cudUpdate: '[Discapacidad] Update certificados de Discapacidad',
  cudDelete: '[Discapacidad] Delete certificados de Discapacidad',

  discapacidadGetNotasSuccess: '[discapacidad] Get Notas Success',
  discapacidadGetNotasError: '[discapacidad] Get Notas Error',
  discapacidadGetTipoNotasSuccess: '[discapacidad] Get Tipo Notas Success',
  discapacidadGetTipoNotasError: '[discapacidad] Get Tipo Notas Error',

  //EMPADRONAMIENTO
  empadronamientoGetTiposEmpadronamientosSuccess: '[Empadronamiento] Get Tipos Empadronamiento Success',
  empadronamientoGetTiposEmpadronamientosError: '[Empadronamiento] Get Tipos Empadronamiento Error',
  empadronamientoSetSolicitudSeleccionada: '[Empadronamiento] Set Solicitud Seleccionada',
  empadronamientoCleanSolicitudSeleccionada: '[Empadronamiento] Clean Solicitud Seleccionada',
  empadronamientoUpdateSolicitudSeleccionada: '[Empadronamiento] Update Solicitud Seleccionada',
  empadronamientoSetMedicamentos: '[Empadronamiento] Set Medicamentos',
  empadronamientoGetMedicamentosSuccess: '[Empadronamiento] Get Medicamentos Success',
  empadronamientoGetTiposDocumentacionSuccess: '[Empadronamiento] Get TipoDocumentacion Success',
  empadronamientoGetTiposDocumentacionError: '[Empadronamiento] Get TipoDocumentacion Error',
  empadronamientoGetDocumentacionSuccess: '[Empadronamiento] Get Documentacion Success',
  empadronamientoGetDocumentacionError: '[Empadronamiento] Get Documentacion Error',
  empadronamientoSetShowForm: '[Empadronamiento] Set Show Form',
  empadronamientoUpdateEstadoMedicacion: '[Empadronamiento] Update Estado Medicacion',
  empadronamientoUpdateEstadoSolicitudes: '[Empadronamiento] Update Estado Solicitud',
  empadronamientoUpdateEstadoSolicitudesConsulta: '[Empadronamiento] Update Estado Solicitud-Consulta',
  empadronamientoUpdateEstadoMedicacionConsulta: '[Empadronamiento] Update Estado Medicacion-Consulta',
  empadronamientoCleanSolicitudes: '[Empadronamiento] Clean Solicitudes',
  empadronamientoClearReducer: '[Empadronamiento] Clear Reducer',
  empadronamientoGetContadoresSolicitudesSuccess: '[Empadronamiento] Get Contadores Solicitudes Success',
  empadronamientoGetContadoresSolicitudesError: '[Empadronamiento] Get Contadores Solicitudes Error',
  empadronamientoSetSolicitudSeleccionadaMedicamentos: '[Empadronamiento] Set Medicamentos Seleccionada',
  empadronamientoSetSolicitudSeleccionadaDiagnosticos: '[Empadronamiento] Set Medicamentos Seleccionada',
  empadronamientoGetSolicitudesSuccess: '[Empadronamiento] Get Solicitudes Success',
  empadronamientoGetSolicitudesHistorialSuccess: '[Empadronamiento] Get Solicitudes Historial Success',
  empadronamientoGetSolicitudesHistorialMedSuccess: '[Empadronamiento] Get SolicitudesMed Historial Success',
  empadronamientoGetSolicitudesHistorialMigraSuccess: '[Empadronamiento] Get SolicitudesMigra Historial Success',
  empadronamientoGetSolicitudesActivasSuccess: '[Empadronamiento] Get Solicitudes Activas Success',
  empadronamientoGetSolicitudesError: '[Empadronamiento] Get Solicitudes Error',
  empadronamientoGetSolicitudesHistorialError: '[Empadronamiento] Get Solicitudes Historial Error',
  empadronamientoGetSolicitudesHistorialMedError: '[Empadronamiento] Get SolicitudesMed Historial Error',
  empadronamientoGetSolicitudesHistorialMigraError: '[Empadronamiento] Get SolicitudesMigra Historial Error',
  empadronamientoGetSolicitudesActivasError: '[Empadronamiento] Get Solicitudes Activas Error',
  empadronamientoSetStep: '[Empadronamiento] Set Step',
  empadronamientoSetAfiliadoSeleccionado: '[Empadronamiento] Set Afiliado Seleccionado',
  empadronamientoCleanAfiliadoSeleccionado: '[Empadronamiento] Clean Afiliado Seleccionado',
  empadronamientoGetBuscadorTiposEmpadronamientoSuccess: '[Empadronamiento] GET Buscador Tipos Empadronamiento Success',
  empadronamientoGetBuscadorTiposEmpadronamientoError: '[Empadronamiento] GET Buscador Tipos Empadronamiento Error',
  empadronamientoResetBuscadorTiposEmpadronamiento: '[Empadronamiento] Reset Buscador Tipos Empadronamiento',
  empadronamientoAnularSolicitudSuccess: '[Empadronamiento] Anular Solicitud Success',
  empadronamientoAddMedicamento: '[Empadronamiento] Add Medicamento',
  empadronamientoReplaceMedicamentosPorSeleccionados: '[Empadronamiento] Replace Medicamentos',
  empadronamientoGetMedicamentosEmpSuccess: '[Empadronamiento] Get Medicamentos de Empadronamiento Success',
  empadronamientoGetMedicamentosEmpError: '[Empadronamiento] Get Medicamentos de Empadronamiento Success',
  empadronamientoGetTrackingSolicitudSuccess: '[Empadronamiento] Get Tracking Solicitud Success',
  empadronamientoGetTrackingSolicitudError: '[Empadronamiento] Get Tracking Solicitud Error',
  empadronamientoGetTrackingSolicitudMedicacionSuccess: '[Empadronamiento] Get Tracking Solicitud Medicacion Success',
  empadronamientoGetTrackingSolicitudMedicacionError: '[Empadronamiento] Get Tracking Solicitud Medicacion Error',

  empadronamientoMedicamentos310TraerStart: '[Empadronamiento]  Inicio Medicamentos310',
  empadronamientoMedicamentos310TraerSuccess: '[Empadronamiento]  Traida de medicamentos310 Success',
  empadronamientoMedicamentos310TraerError: '[Empadronamiento]  Traida de medicamentos310 Error',
  empadronamientoMedicamentos310SetActivosPorFecha: '[Empadronamiento] SET Activos Por Fecha',

  empadronamientoGetDocumentacionMedicacionSuccess: '[Empadronamiento] Get Documentacion Medicacion Success',
  empadronamientoSetTipoEmpadronamiento: '[Empadronamiento] set id tipo empadronamiento',

  empadronamientoGetDisponibilidadScienzaSucces: '[Empadronamiento] Get Disponibilidad de medicamentos scienza',
  empadronamientoGetDisponibilidadScienzaError: '[Empadronamiento] Get Disponibilidad de medicamentos scienza error',

  empadronamientosGetPatologias: '[Empadronamiento] Get patologias empadronamiento success',

  empadronamientoGetTiposDocumentacionMedicacionSuccess: '[Empadronamiento] Get TipoDocumentacionMedicacion Success',
  empadronamientoGetNotasSuccess: '[Empadronamiento] Get Notas Success',
  empadronamientoGetNotasError: '[Empadronamiento] Get Notas Error',
  empadronamientoMedicacionGetNotasSuccess: '[Empadronamiento] Get Notas Medicacion Success',
  empadronamientoMedicacionGetNotasError: '[Empadronamiento] Get Notas Medicacion Error',

  empadronamientoGetTiposNotasSuccess: '[empadronamiento] Get Tipos Notas Empadronamiento Success',
  empadronamientoGetTiposNotasError: '[empadronamiento] Get Tipos Notas Empadronamiento Error',

  empadronamientoGetTrackingScienzaSuccess: '[Empadronamiento] Get Tracking Scienza Success',
  empadronamientoGetTrackingScienzaError: '[Empadronamiento] Get Tracking Scienza Error',
  empadronamientoGetConveniosScienzaSuccess: '[empadronamiento] Get Convenios Scienza Empadronamiento Success',
  empadronamientoGetConveniosScienzaError: '[empadronamiento] Get Convenios Scienza Empadronamiento Error',

  empadronamientoGetTrackingNosConectaSuccess: '[Empadronamiento] Get Tracking NosConecta Success',
  empadronamientoGetTrackingNosConectaError: '[Empadronamiento] Get Tracking NosConecta Error',

  empadronamientoAlertasSuccess: '[Empadronamiento] Get Alertas Empadrodamiento Success',
  empadronamientoAlertasError: '[Empadronamiento] Get Alertas Empadrodamiento Error',

  // AREAS FISICAS
  areasFisicasReducerStart: '[Areas Fisicas] Start Loading Areas Fisicas Reducer',
  areasFisicasReducerEnd: '[Areas Fisicas] End Loading Areas Fisicas Reducer',
  getAreasFisicas: '[Areas Fisicas] Get Areas Fisicas',
  cleanAreasFisicas: '[Areas Fisicas] Clean Areas Fisicas',
  getSubAreasFisicas: '[Areas Fisicas] Get Sub Areas Fisicas',
  cleanSubAreasFisicas: '[Areas Fisicas] Clean Sub Areas Fisicas',
  getUsuarioAreasFisicas: '[Areas Fisicas] Get Usuario Areas Fisicas',
  cleanUsuarioAreasFisicas: '[Areas Fisicas] Clean Usuario Areas Fisicas',
  newStateAreaFisica: '[Areas Fisicas] New State Usuario Areas Fisicas',
  deleteAreaFisica: '[Areas Fisicas] Delete Usuario Areas Fisicas',
  putAreaFisica: '[Areas Fisicas] Put Areas Fisicas',
  removeAreaFisica: '[Areas Fisicas] Remove Area Fisicas',
  newAreaFisica: '[Areas Fisicas] New Area Fisicas',

  //SUBAREASFISICAS
  abmTraerSubAreasFisicasSuccess: '[SubAreasFicias Traer]',
  abmTraerAreasFisicasSuccess: '[AreasFisicas Traer]',
  abmBuscarSubAreasFisicas: '[SubAreasFisicas Buscar]',

  //Surge-Patologias
  abmPatologias: '[abmPatologias]  trae Patologias',
  abmPracticasAgrupadasTraerTiposSuccess: '[abmPatologias]  Traida de Patologias Success',
  abmPatologiasError: '[abmPatologias]  Traida de Patologias Error',
  abmPracticasAgrupadasBuscarTipo: '[abmPatologias]   Filtrar Patologias',
  abmModificarPatologias: '[abmPatologias]  Modificar Patologias',
  //Surge Practicas y Dispositivos
  abmPracticasYDispositivosSuccess: '[abmPracticasYDispositivos] Traer practicas y dispositivos success',
  abmBuscarPracticasDispositivos: '[abmPracticasYDispositivos]   Filtrar Practicas Y Dispositivos',
  //Surge Conceptos
  getConceptosSurge: '[Conceptos Surge] Traer Conceptos',
  cleanConceptosSurge: '[Conceptos Surge] Clean Conceptos',
  insertConceptoSurge: '[Conceptos Surge] Insert Concepto',
  removeConceptoSurge: '[Conceptos Surge] Remove Concepto',
  updateConceptoSurge: '[Conceptos Surge] Update Concepto',

  //RECLAMOS
  setActiveBreadcrumbReclamo: '[reclamos] Set Active Breadcrumb Reclamos',
  reclamosSetDataAfiliado: '[reclamos] Set Data Afiliado Reclamos',
  reclamosSetDataEfector: '[reclamos] Set Data Efector Reclamos',
  reclamosSetDataExternos: '[reclamos] Set Data Externos Reclamos',
  reclamosAfiliadoLimpiarSeleccion: '[reclamos] Reset Data Afiliado Reclamos',
  reclamosEfectorLimpiarSeleccion: '[reclamos] Reset Data Efector Reclamos',
  reclamosExternosLimpiarSeleccion: '[reclamos] Reset Data Externos Reclamos',
  reclamosSetTipoReclamo: '[reclamos] Set tipo Reclamos',
  reclamosSetTipoOrigen: '[reclamos] Set tipo Origen',
  reclamosSetStep: '[reclamos] Set step',
  listaTipoReclamosSuccess: '[reclamos] Lista Tipo Reclamos',
  listaTipoOrigenesSuccess: '[reclamos] Lista Tipo Origenes',
  listaCategoriasReclamosSuccess: '[reclamos] Lista Categorias Reclamos',
  tomarReclamoIngresado: '[reclamos] Tomar Reclamo Ingresado',
  traerReclamoPorId: '[reclamos] Traer reclamo por id',
  traerReclamoPorIdAfiliado: '[reclamos] Traer reclamo por id Afiliado',
  traerReclamoPorIdEfector: '[reclamos] Traer reclamo por id Efector',
  traerReclamoPorCuit: '[reclamos] Traer reclamo por cuit',
  traerReclamosEnviados: '[reclamos] Traer reclamo enviados success',
  cleanReclamosEnviados: '[reclamos] clean reclamo enviados success',
  traertipoComentarioReclamos: '[reclamos] Traer tipo Documentaciones reclamos success',
  reclamosUpdateEstadoSolicitudes: '[reclamos] update estado solicitudes',
  trackingReclamos: '[reclamos] Tracking Reclamos',
  traerReclamosTodos: '[reclamos] Traer Reclamos Todos',
  traerReclamosEfectoresTodos: '[reclamos] Traer Reclamos efector Todos',
  traerReclamosExternosTodos: '[reclamos] Traer Reclamos externos Todos',
  reclamosSetSolicitudSeleccionada: '[reclamos] set solicitud Seleccionada Datos',
  reclamosGetContadoresSolicitudesSuccess: '[reclamos] traer contadores',
  reclamosGetComentariosSolicitudesSuccess: '[reclamos] traer comentarios',
  putTipoReclamo: '[reclamos] Modifica tipo reclamo',
  removeTipoReclamo: '[reclamos] Elimina tipo reclamo',
  newTipoReclamo: '[reclamos] Nuevo tipo reclamo',
  putOrigenReclamo: '[reclamos] Modifica origen reclamo',
  removeOrigenReclamo: '[reclamos] Elimina origen reclamo',
  newOrigenReclamo: '[reclamos] Nuevo origen reclamo',
  putCategoriaReclamo: '[reclamos] Modifica categoria reclamo',
  removeCategoriaReclamo: '[reclamos] Elimina categoria reclamo',
  newCategoriaReclamo: '[reclamos] Nueva categoria reclamo',
  listaOrigenErrorReclamoSuccess: '[reclamos] Lista Origen Error Reclamos',
  traerEfectorReclamo: '[reclamos] Traer EfectorReclamo reclamo',
  documentacionReclamosClean: '[reclamos] Documentacion Reclamo Clean',
  documentacionReclamosSucces: '[reclamos] Documentacion Reclamo Succes',
  documentacionReclamosInsert: '[reclamos] Documentacion reclamo Insert',
  documentacionReclamosEliminar: '[reclamos] Documentacion Reclamos Eliminar',
  documentacionReclamosError: '[reclamos] Documentacion Reclamos Error',
  recepcionReclamoSetMenu: '[reclamos] set menu Reclamos',
  documentacionReclamosEfectorClean: '[reclamos] Documentacion Reclamo Efector Clean',
  documentacionReclamosEfectorSucces: '[reclamos] Documentacion Reclamo Efector Succes',
  documentacionReclamosEfectorInsert: '[reclamos] Documentacion reclamo Efector Insert',
  documentacionReclamosEfectorEliminar: '[reclamos] Documentacion Reclamos Efector Eliminar',
  documentacionReclamosEfectorError: '[reclamos] Documentacion Reclamos Efector Error',
  documentacionReclamosExternoClean: '[reclamos] Documentacion Reclamo Externo Clean',
  documentacionReclamosExternoSucces: '[reclamos] Documentacion Reclamo Externo Succes',
  documentacionReclamosExternoInsert: '[reclamos] Documentacion reclamo Externo Insert',
  documentacionReclamosExternoEliminar: '[reclamos] Documentacion Reclamos Externo Eliminar',
  documentacionReclamosExternoError: '[reclamos] Documentacion Reclamos Externo Error',

  reclamosTomadosSuccess: '[reclamos Tomados] Traida de reclamos Tomados Success',
  reclamosTomadosError: '[reclamos Tomados] reclamos Tomados Error',
  reclamosTomadosUsuarioSuccess: '[reclamos Tomados] Traida de reclamos Tomados Por Usuario Success',
  reclamosTomadosUsuarioError: '[reclamos Tomados] reclamos Tomados Por Usuario Usuario Error',
  reclamosTomadosUsuarioAgregar: '[reclamos Tomados] Agregar reclamos Tomados',
  reclamosTomadosLiberar: '[reclamos Tomados] Liberar reclamos Tomados',
  reclamosTomadosUsuarioLiberar: '[reclamos Tomados] Liberar reclamos Tomados Usuario',
  reclamosTomadosLimpiar: '[reclamos Tomados] Limpia reclamos Tomados',
  reclamosTomadosLiberarTomadoPorIdReclamo: '[reclamos Tomados] liberar reclamo tomado por id reclamo',
  reclamosMarcarTomado: '[reclamos Tomados] marcar reclamo como tomado',

  

  //COMUNICACION CON EMPRESAS
  traerEstadosComunicacionSuccess:
    '[ComunicacionConEmpresas] Traer estados comunicacion success',
  traerEstadosComunicacionError:
    '[ComunicacionConEmpresas] Traer estados comunicacion error',
  updateEstadosSolicitudComunicacion:
    '[ComunicacionConEmpresas] Setear valor de estado',
  traerDatosSuspensionEmpresaSuccess:
    '[ComunicacionConEmpresas] Traer datos suspension de empresas success',
  traerDatosSuspensionEmpresaError:
    '[ComunicacionConEmpresas] Traer datos suspension de empresas error',
  traerDatosSuspensionAfiliadosSuccess:
    '[ComunicacionConEmpresas] Traer datos suspension de afiliados success',
  traerDatosSuspensionAfiliadosError:
    '[ComunicacionConEmpresas] Traer datos suspension de afiliados error',
  limpiarDatosSuspensionEmpresas:
    '[ComunicacionConEmpresas] Limpiar datos suspension empresa',
  traerSolicitudesComunicacionSuccess:
    '[ComunicacionConEmpresas] Traer Solicitudes Comunicacion success',
  traerSolicitudesComunicacionError:
    '[ComunicacionConEmpresas] Traer Solicitudes Comunicacion error',
  traerMensajesComunicacionSuccess:
    '[ComunicacionConEmpresas] Traer mensajes comunicacion success',
  traerMensajesComunicacionError:
    '[ComunicacionConEmpresas] Traer mensajes comunicacion error',
  traerObservacionesEmpresaSuccess:
    '[ComunicacionConEmpresas] Traer Observaciones Empresa success',
  traerObservacionesEmpresaError:
    '[ComunicacionConEmpresas] Traer Observaciones Empresa error',
  getDocumentacionPorCuitEmpresaSuccess:
    '[ComunicacionConEmpresas] Traer documentacion comunicacion con empresas success',
  getDocumentacionPorCuitEmpresaError:
    '[ComunicacionConEmpresas] Traer documentacion comunicacion con empresas error',
  actualizarSeguimientoEmpresasSuccess:
    '[Empresas] Actualizar seguimiento empresa success',
  traerSeguimientoEmpresaSuccess: '[Empresas] Traer seguimiento empresas',
  limpiarSeguimientoEmpresaSuccess: '[Empresas] Limpiar seguimiento',
  seleccionarEmpresaComunicacion: '[Comunicacion con Empresas] seleccionar empresa comunicacion',
  desSeleccionarEmpresaComunicacion: '[Comunicacion con Empresas] limpiar empresa comunicacion',
  buscarSolicitudXUsuario: '[Comunicacion con Empresas] buscar solicitud por usuario',
  buscarSolicitudXUsuarioAfiliaciones : '[Comunicacion con Empresas] buscar solicitud por usuario afiliaciones',
  limpiarObservaciones: '[Comunicacion con Empresas] limpiar observaciones empresa',
  filtrarPorEstadoSemaforo: '[Comunicacion con Empresas] filtrar solicitudes segun estado semaforo',
  fechaCargaDesdeComunicacion: '[Comunicacion con Empresas] fecha carga desde filtro',
  fechaCargaHastaComunicacion: '[Comunicacion con Empresas] fecha carga hasta filtro',
  fechaUltimaModificacionDesdeComunicacion: '[Comunicacion con Empresas] fecha ultima modificacion desde filtro',
  fechaUltimaModificacionHastaComunicacion: '[Comunicacion con Empresas] fecha ultima modificacion hasta filtro',

  //HCE
  setActiveBreadcrumbHce: '[Hce] Set Active Breadcrumb HCE',
  hceSetStep: '[Hce] Set step',
  reclamosUpdateEstadoTurnos: '[Hce] Set estados turnos',
  listaTurnosSucess: '[Hce] Traer lista de turnos por medico',
  listaHcePaciente: '[Hce] Traer datos hce paciente',
  SetHceSeleccionada: '[Hce] set historia clinica seleccionada',
  setDataAfiliadoHCE: '[Hce] set data afiliacion',
  documentacionHCEClean: '[Hce] Documentacion Reclamo Clean',
  documentacionHCESucces: '[Hce] Documentacion Reclamo Succes',
  documentacionHCEInsert: '[Hce] Documentacion reclamo Insert',
  documentacionHCEEliminar: '[Hce] Documentacion Reclamos Eliminar',
  documentacionHCEError: '[Hce] Documentacion Reclamos Error',
  problemasAfiliadoSucces: '[Hce] Traer Problemas Afiliados',
  evolucionesAfiliadoSucces: '[Hce] Traer Evoluciones Afiliados',
  hceEmpadronamientoSetStep: '[Hce] set Active Step Empranonamiento',
  hceSetAfiliadoSeleccionado: '[Hce] set afiliado seleccionado ',
  informesAfiliadoSucces: '[Hce] traer informes Afiliado ',
  informesOftalmologiaActivaSuccess: '[Hce] traer informes oftalmologia Afiliado ',
  protocoloImagenesSucces: '[Hce] traer protocolo imagenes ',
  protocoloImagenesPorIdSucces: '[Hce] traer protocolo imagenes por id ',
  protocolosOftalmologiaActivaSuccess: '[Hce] traer protocolos oftalmologia ',
  abmInformesSucces: '[Hce] traer informes todos ',
  abmBuscarInformes: '[Hce] buscar informes abm ',
  abmBuscarInformesOftalmologia: '[Hce] buscar informes oftalmologia abm ',
  abmBuscarEstudiosMedicos: '[Hce] buscar estudio medico abm ',
  ambEfectoresmedicosSucces: '[Hce] Traer Efectores Medicos abm ',
  estadosProblemasSucces: '[Hce] Traer Estados Problemas Succes ',
  recordatorioGeneralSucces: '[Hce] Traer recordatorio general Succes ',
  recordatorioPropioSucces: '[Hce] Traer recordatorio propio Succes ',
  documentacionOdontoHCEClean: '[Hce] Documentacion odontologia Clean',
  documentacionOdontoHCESucces: '[Hce] Documentacion Reclodontologiaamo Succes',
  documentacionOdontoHCEInsert: '[Hce] Documentacion odontologia Insert',
  documentacionOdontoHCEEliminar: '[Hce] Documentacion odontologia Eliminar',
  documentacionOdontoHCEError: '[Hce] Documentacion odontologia Error',
  documentacionEmpHCEClean: '[Hce] Documentacion Empadronamiento HCE Clean',
  documentacionEmpHCESucces: '[Hce] Documentacion Empadronamiento HCE Succes',
  documentacionEmpHCEInsert: '[Hce] Documentacion Empadronamiento HCE Insert',
  documentacionEmpHCEEliminar: '[Hce] Documentacion Empadronamiento HCE Eliminar',
  documentacionEmpHCEError: '[Hce] Documentacion Empadronamiento HCE Error',
  evolucionGeneralOdontologiaSucces:
    '[Hce] evoluciones generales odontologia Succes',
  problemasOdontologiaSucces: '[Hce] problemas odontologia Succes',
  evolucionOdontologiaSucces: '[Hce] evoluciones odontologia Succes',
  listaEfectorMedicoSucess: '[Hce] traer efector medico lista Succes',
  pisoConsultorioEfectorSucess: '[Hce] traer piso y consultorio medico Succes',
  relacionEfectorCMEspeSucess:
    '[Hce] traer relacion efector centro medico y especialidad Succes',
  signosVitalesSuccess: '[Hce] traer signos vitales Succes',
  vacunasSuccess: '[Hce] traer vacunas Succes',
  medicacionActivaSuccess: '[Hce] traer medicacion activa Succes',
  turnoTeleconsultaSucess: '[Hce] traer turno teleconsulta Succes',
  turnosProximosAfiliadoSucess: '[Hce] traer turnos proximos afiliado Succes',
  salaEsperaAfiliadosSuccess: '[Hce] traer sala espera afiliados Succes',
  hceAutopercepcionAfiliadoGetSuccess: '[Hce] traer afiliado autopercepcion Succes',
  hceAutopercepcionAfiliadoGetError: '[Hce] afiliado autopercepcion error',
  hceAutopercepcionAfiliadoClear: '[Hce] afiliado autopercepcion clear',
  hceClearReducer: '[Hce] crear de state de HCE',
  estudiosSolicitadosSucess: '[Hce] traer estudios solicitados Succes',
  estudiosMedicosSucess: '[Hce] traer estudios medicos Succes',
  turnosAfiliadosSucess: '[Hce] traer turnos afiliado medicos Succes',

  //ABM COSEGUROS EXTERNOS
  abmCosegurosExternosSuccess: '[AbmCosegurosExternos] Traer coseguros externos success',
  abmBuscarCosegurosExternos: '[AbmCosegurosExternos] buscador coseguros externos success',
  abmPracticasCosegurosExternosSuccess: '[AbmCosegurosExternos] traer practicas coseguros externos success',
  abmBuscarPracticasCosegurosExternos: '[AbmCosegurosExternos] buscador practicas coseguros externos success',
  abmCodNomAutorSuccess: '[AbmCosegurosExternos] Traer Codigo Nomenclaro Autor success',

  //ABM PRESTADORES RESTRINGIDOS
  abmPrestadoresRestringidosTraerStart: '[AbmPrestadoresRestringidos] Traer prestadores restringidos start',
  abmPrestadoresRestringidosTraerSuccess: '[AbmPrestadoresRestringidos] Traer prestadores restringidos success',
  prestadoresRestringidosTraerError: '[AbmPrestadoresRestringidos] Traer prestadores restringidos error',
  abmBuscarPrestadoresRestringidos: '[AbmPrestadoresRestringidos] Buscar prestadores restringidos error',
  abmPracticasPrestadoresRestringidosSuccess: '[AbmPrestadoresRestringidos] Traer practicas prestadores restringidos error',
  abmBuscarPracticasRestringidosSuccess: '[AbmPrestadoresRestringidos] Buscar practicas prestadores restringidos error',

  //HISTORIAL CONSUMOS 
  historialConsumosCleanReducer: '[HistorialConsumos] Clean Reducer',
  discapacidadGetConsumosAfiliadosSuccess: '[HistorialConsumos] get consumos disca',

  //VERSIONES SISTEMA
  abmVersionadoSuccess: '[abmVersionado] Traer versiones sistema success',
  abmBuscarVersionado: '[abmVersionado] Buscar versiones sistema success',

  //LABORATORIO
  laboratorioGetPracticasSuccess: '[laboratorio] GET Practicas Success',
  laboratorioGetPracticasError: '[laboratorio] GET Practicas Error',
  laboratorioCleanPracticas: '[laboratorio] Vaciar Practicas',
  // laboratorioGetBuscadorPracticasSuccess: '[laboratorio] GET Buscador Practicas Success',
  // laboratorioGetBuscadorPracticasError: '[laboratorio] GET Buscador Practicas Error',
  // laboratorioResetBuscadorPracticas: '[laboratorio] Reset Buscador Practicas',
  laboratorioAddPractica: '[laboratorio] Add Practica',
  laboratorioSetPracticasSeleccionadas: '[laboratorio] Set Practicas Seleccionads',
  laboratorioSetGruposSeleccionados: 'laboratorioSetGruposSeleccionados',
  laboratorioCleanGruposSeleccionados: 'laboratorioCleanGruposSeleccionados',
  laboratorioCleanPracticasSeleccionadas: '[laboratorio] Clean Practicas Seleccionads',
  laboratorioSetDocumentacion: '[laboratorio] Add Documentacion',
  laboratorioDeleteDocumentacion: '[laboratorio] Delete Documentacion',
  laboratorioCleanDocumentacion: '[laboratorio] Clean Documentacion',
  laboratorioSetSolicitudes: '[laboratorio] Set Solicitudes',
  laboratorioSetSolicitudesAutorizadas: '[laboratorio] Set Solicitudes Autorizadas',
  laboratorioClear: '[laboratorio] Clear',

  //CERTIFICADO ATENCION
  certificadoAtencionClearReducer: '[certificadoAtencion] Clear Reducer',
  certificadoAtencionSetStep: '[certificadoAtencion] Set Step',
  certificadoAtencionSetAfiliadoSeleccionado: '[certificadoAtencion] Set Afiliado Seleccionado',
  certificadoAtencionCleanAfiliadoSeleccionado: '[certificadoAtencion] Clean Afiliado Seleccionado',
  certificadoAtencionUpdateAfiliadoSeleccionado: '[certificadoAtencion] Update Afiliado Seleccionado',
  certificadoAtencionSetShowForm: '[certificadoAtencion] Set Show Form',
  certificadosAtencionSucess: '[certificadoAtencion] Certificados Success',
  setCertificadoAtencionSeleccionado: '[certificadoAtencion] set Certificado seleccionado',

  //ADICCIONES
  adiccionesGetTrackingSolicitudSuccess: '[adicciones] Get Tracking Solicitud Success',
  adiccionesGetTrackingSolicitudError: '[adicciones] Get Tracking Solicitud Error',
  adiccionesGetTiposSolicitudesSuccess: '[adicciones] Traer Tipos de Solicitudes Success',
  adiccionesGetTiposSolicitudesError: '[adicciones] Traer Tipos de Solicitudes Error',
  adiccionesGetTiposDocumentacionSuccess: '[adicciones] Get Tipo Documentacion Success',
  adiccionesGetTiposDocumentacionError: '[adicciones] Get Tipo Documentacion Error',
  adiccionesGetTiposDocumentacionSuccessAbm: '[adicciones] Get Tipo Documentacion Abm Success',
  adiccionesGetTiposDocumentacionErrorAbm: '[adicciones] Get Tipo Documentacion Abm Error',
  adiccionesCleanTiposDocumentacionAbm: '[adicciones] Clean Tipo Documentacion Abm',
  adiccionesPostTiposDocumentacionAbm: '[adicciones] Post Tipo Documentacion Abm',
  adiccionesPutTiposDocumentacionAbm: '[adicciones] Put Tipo Documentacion Abm',
  adiccionesDeleteTiposDocumentacionAbm: '[adicciones] Delete Tipo Documentacion Abm',

  adiccionesPutTiposDocumentacion: '[adicciones] Put Tipo Documentacion ',
  adiccionesPostTiposDocumentacion: '[adicciones] Post Tipo Documentacion ',
  adiccionesDeleteTiposDocumentacion: '[adicciones] Delete Tipo Documentacion ',

  adiccionesGetContadoresSolicitudesSuccess: '[adicciones] Get Contadores Solicitudes Success',
  adiccionesGetContadoresSolicitudesError: '[adicciones] Get Contadores Solicitudes Error',
  adiccionesGetSolicitudesSuccess: '[adicciones] Get Solicitudes Success',
  adiccionesGetSolicitudesError: '[adicciones] Get Solicitudes Error',

  adiccionesSolicitudesTomadasUsuarioSuccess: '[adicciones] Traida de solicitudes Tomadas Por Usuario Success',
  adiccionesSolicitudesTomadasUsuarioError: '[adicciones] solicitudes Tomadas Por Usuario Usuario Error',
  adiccionesSolicitudesTomadasUsuarioLiberar: '[adicciones] Liberar solicitudes adicciones Tomadas Usuario',
  adiccionesSolicitudesDesmarcarLiberada: '[adicciones] solicitudes adicciones desmarcar Tomada',
  adiccionesSolicitudesTomadasLiberar: '[adicciones] Liberar solicitudes adicciones Tomadas',
  adiccionesSolicitudesTomadasUsuarioAgregar: '[adicciones] Agregar solicitudes adicciones Tomadas',
  adiccionesSolicitudesMarcarTomada: '[adicciones] solicitudes adicciones marcar Tomadas',
  adiccionesSolicitudesTomadasLimpiar: '[adicciones] Limpia solicitudes adicciones Tomadas',

  adiccionesClearReducer: '[adicciones] Clean Reducer',
  adiccionesSetBreadcrumbCud: '[adicciones] Modificacion breadcrumb solicitudes Adicciones',
  adiccionesSetStep: '[adicciones] Set Step de Adicciones',
  adiccionesSetAfiliadoSeleccionado: '[adicciones] Set Afiliado Seleccionado',
  adiccionesCleanAfiliadoSeleccionado: '[adicciones] Clean Afiliado Seleccionado',
  adiccionesSetEfectorSeleccionado: '[adicciones] Set Efector Seleccionado',
  adiccionesCleanEfectorSeleccionado: '[adicciones] Clean Efector Seleccionado',
  adiccionesSetEstadoSolicitudes: '[adicciones] Set Estado Solicitudes',
  adiccionesCleanSolicitudes: '[adicciones] Clean Solicitudes',
  adiccionesCleanSolicitudSeleccionada: '[adicciones] CleanSolicitudSeleccionada',
  adiccionesSetSolicitudSeleccionada: '[adicciones] Set Solicitudes Seleccionada',
  adiccionesUpdateSolicitudSeleccionada: '[adicciones] Update Solicitudes Seleccionada',
  adiccionesAddPractica: '[adicciones] Add Practica',
  adiccionesSetPracticas: '[adicciones] Set Practicas',
  adiccionesGetPracticasSuccess: '[adicciones] Get Practicas Success',
  adiccionesGetDocumentacionSuccess: '[adicciones] Get Documentacion Success',
  adiccionesGetDocumentacionError: '[adicciones] Get Documentacion Error',
  adiccionesSolicitudesTomadasSuccess: '[adicciones] Traida de solicitudes adicciones Tomadas Success',
  adiccionesSolicitudesTomadasError: '[adicciones] solicitudes adicciones Tomadas Error',

  adiccionesGetNotasSuccess: '[adicciones] Get Notas Success',
  adiccionesGetNotasError: '[adicciones] Get Notas Error',
  adiccionesGetConsumosAfiliadosSuccess: '[adicciones] get consumos disca',

  //PRACTICAS AGRUPADAS GRUPO
  practicasAgrupadasTraerGruposSuccess: 'practicasAgrupadasTraerGruposSuccess',
  practicasAgrupadasBuscarGrupo: 'practicasAgrupadasBuscarGrupo',
  practicasAgrupadasTraerGruposError: 'practicasAgrupadasTraerGruposError',
  //PRACTICAS AGRUPADAS PRACTICAS
  practicasAgrupadasTraerPracticasSuccess: 'practicasAgrupadasTraerPracticasSuccess',
  practicasAgrupadasTraerPracticasError: 'practicasAgrupadasTraerPracticasError',
  practicasAgrupadasBuscarPractica: 'practicasAgrupadasBuscarPractica',

  usuariosOspeDirectoSuccess: '[usuariosOspeDirecto] Get usuarios ospe directo Success',
  usuariosOspeDirectoBuscar: '[usuariosOspeDirecto] Buscador usuarios ospe directo Success',

  //ESTUDIOS MEDICOS
  estudiosMedicosClearReducer: '[estudiosMedicos] Clean estudios medicos',
  estudiosMedicosUpdateEstado: '[estudiosMedicos] estudios medicos update estado',
  estudiosMedicosSetAfiliadoSeleccionado: '[estudiosMedicos] estudios medicos set afiliado seleccionado',
  estudiosMedicosCleanAfiliadoSeleccionado: '[estudiosMedicos] estudios medicos clean afiliado seleccionado',
  estudiosMedicosUpdateAfiliadoSeleccionado: '[estudiosMedicos] estudios medicos update afiliado seleccionado',
  estudiosMedicosGetSuccess: '[estudiosMedicos] traer estudios medicos success',
  estudiosMedicosClean: '[estudiosMedicos] clean estudios medicos ',
  estudiosMedicosGetError: '[estudiosMedicos] error estudios medicos ',
  estudiosMedicosGetContadoresSuccess: '[estudiosMedicos] traer contadores estudios medicos success',
  estudiosMedicosGetContadoresError: '[estudiosMedicos] traer contadores estudios medicos error',
  estudiosMedicosSetSeleccionado: '[estudiosMedicos] set estudio medico',
  estudiosMedicosUpdatePorid: '[estudiosMedicos] update estudio medico por id',
  estadosEstudiosMedicosGetSuccess: '[estudiosMedicos] estados estudios medicos get succes',
  estadosEstudiosMedicosGetError: '[estudiosMedicos] estados estudios medicos get error',
  informesMedicosGetSuccess: '[estudiosMedicos] informes medicos get succes',
  informesMedicosGetError: '[estudiosMedicos] informes medicos get error',
  trackingEstudiosMedicosGetSuccess: '[estudiosMedicos] tracking estudios medicos get succes',
  trackingEstudiosMedicosGetError: '[estudiosMedicos] tracking estudios medicos get error',
  notasEstudiosMedicosGetSuccess: '[estudiosMedicos] notas estudios medicos get succes',
  notasEstudiosMedicosGetError: '[estudiosMedicos] notas estudios medicos get error',
  tipoNotasEstudiosMedicosGetSuccess: '[estudiosMedicos]  tipoNotas estudios medicos get succes',
  tipoNotasEstudiosMedicosGetError: '[estudiosMedicos]  tipoNotas estudios medicos get error',
  estudiosMedicosCleanAfiliado: '[estudiosMedicos] estudios medicos clean afiliado ',
  estudiosMedicosSetAfiliado: '[estudiosMedicos] estudios medicos update afiliado ',
};
